import { Component, OnInit, AfterViewInit, HostListener,EventEmitter, Output } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import { LookupService, ApplicationService, DataService, BaseService } from '../../services';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BankDetailsModel, AccountApplicationModel, PersonIncomeDetailModel, DocumentDetailsModel, crsDetailsModel, benDetailsModel, FatcaDetailsModel } from '../../models';
import { NationalityModel } from '../../models';
import { Route } from '@angular/compiler/src/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ViewChild, ElementRef } from '@angular/core';
import { MatStepper, MatDialog } from '@angular/material';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { AppConfig } from '../../_config'
import { DaoDialogComponent, DaoDropdownComponent } from 'src/app/directives';
import { DocumentAttachmentComponent } from '../document-attachment/document-attachment.component';
import { DeclarationsComponent } from '../declarations/declarations.component'
import { CommonHelper } from 'src/app/_modules/shared';
import { applicantDetailsModel } from 'src/app/models/account-opening-models/applicant-details.model';
import { FirebaseService } from 'src/app/services/firebase.service';
import * as converter from 'number-to-words';
import { parse } from 'querystring';

const masterFieldNames = ['FatherSpouseName', 'CoApplicantName', 'Cnic', 'ContactNumberPak', 'RelationWithApplicant',
  'IncomeClubbedWithCoApplicant', 'panelExpanded'];


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit, AfterViewInit {
  // Reference firstNameInput variable inside Component
  @ViewChild('basicDetailsForm') basicDetailsFormRef: ElementRef;
  @ViewChild("start") MyProp: ElementRef;
  @Output() onPaymentBySelf: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild(DocumentAttachmentComponent) documentAttachmentComponent: DocumentAttachmentComponent;
  @ViewChild(DeclarationsComponent) declarationsComponent: DeclarationsComponent;
  @ViewChild('stepper') formStepper:MatStepper;
  public model = {};
  public filteredBranchList = [];
  public filteredDevList = [];
  public filteredTrackerList = [];
  public cityList = [];
  public accountModel: any = {};
  public isStepEditable = true;
  public isStepperLinear = true;
  public showSubmit = false;
  public smallScreen: boolean = false;
  public xSmallScreen: boolean=false;
  logo = '';
  bankDetails: BankDetailsModel[] = [{ NameOfBankUDF: '', TypeOfAccount: '', AccountTitle: '', }];
  personIncomeDetail: PersonIncomeDetailModel[] = [{ MonthlyIncomeAmount: 0, IncomeSourceLkp: 0 }];
  documentModel: DocumentDetailsModel[] = [{ NationalIdTypeLkp: '', NationalIdentifierValue: '', NationalIdIssueDate: '', NationalIdExpiryDate: '', PlaceOfIssue: '' }];
  public applicantDetails: applicantDetailsModel[] = [];
  public coApplicantNomineeDetails: applicantDetailsModel[] = [];

  public Lookups: any = [];
  LookupForDeclaration: any;
  BranchesLookups: any = [];
  TrackerLookups: any = [];
  idLkpsArray: any = [];
  idLkpsArrayPlace: any = [];
  options: FormGroup;
  hideRequiredControl = new FormControl(false);
  floatLabelControl = new FormControl('auto');
  UploadFileControl = new FormControl();
  accountAppModel: any = {};
  startDate = new Date(1990, 0, 1);
  IssueDate = new Date(2018, 0, 1);
  ExpiryDate = new Date(2020, 0, 1);
  currentDate = new Date();
  zakatExemption = true;
  PaymentBySelf = false;
  Single = false;
  CoBorrower = false;
  newCar = false;
  maxFin : number = 999999999;
  maxPropertySize:number=999999;
  maxCoveredArea:number=999999;
  IsManualValid = false;
  IsPakRupeeAccount = false;
  IsAccountSelected = false;
  IsAccount1Selected = false;
  IsAccount2Selected = false;
  IsAccount3Selected = false;
  IsAccount4Selected = false;
  IsAccount5Selected = false;
  IsPakRupeeAccountSav = false;
  IsUSDAccountSav = false;
  ShowApplicant = false;
  ApplicantCount = 1;
  CoApplicantNomineeCount = 0;
  OtpGenerated = false;
  OtpVerified = false;
  Salaried = false;
  SelfEmployed = false;
  Other = false;
  oldApp = false;
  PBSReadOnly = false;
  Otp = 10;
  otp: any;
  countStart: any;
  accessCode:any;
  isDevEnv = false;
  CityId: any;
  zakat: any;
  idLength = 30;
  minPercent = 0;
  PrimaryNationalIdTypeLkpId = 296;
  showSpinner = false;
  addPurposeOne = false;
  addPurposeTwo = false;
  ResidenceNumber = false;
  OfficeNumber = false;
  addNationalityOne = false;
  addNationalityTwo = false;
  allFormsValid = true;
  onlyChild = true;
  onlySourceOfIncome = true;
  onlyNationality = true;
  Disclaimer = '';
  CODisclaimer = '';
  JustLimitApprovalSelected = false;
  GMSSSelected = false;
  PayOrderSelected = false;
  AccountTransferSelected = false;
  Individual = false;
  OtherDeveloper = false;
  Individual1 = false;
  OtherDeveloper1 = false;
  // model variables
  isPassportSelected = false;
  saveInProgress = false;
  showMultipleApplicants = false;
  disableDebitCard = false;
  statementMonthlyLkp: Number;
  public isEstatementFrequencyMandatory = false;
  LienBased = false;
  OtherRelationRequired = false;
  allowExit = false;
  filteredPricingMarkupType = [];
  OPFinancing = false;
  BorrowerDocsRequired = false;
  ShowSPADoc = false;
  ShowNomineeLien = false;
  ShowCoapplicantLien = false;
  ShowSPADocLien = false;
  ShowPartialSubmitDeclaration=false;
  FilteredPropertyToBuy = [];
  AppNumber = null;
  UserId=null;
  ProcessId=null;
  AccountAppId=null;
  theCheckbox;
  theCheckboxPSC = false;
  theCheckboxPSC2=false;
  theCheckboxPSC3=false;

  constructor(private appConfig: AppConfig, private lookupService: LookupService, private baseService: BaseService,public firebase:FirebaseService,
    private applicationService: ApplicationService, public route: ActivatedRoute,private ngxService: NgxUiLoaderService,
    public toastr: ToastrService, public router: Router, private breakpointObserver: BreakpointObserver,
    private loaderService: NgxUiLoaderService, private dialog: MatDialog) {


    this.logo = appConfig.logoPath;
    this.isStepperLinear = !appConfig.testingMode; // if testing mode = true then we dont have to enforce linear stepper
    breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small
    ]).subscribe(result => {
      this.smallScreen = result.matches;
    });
    this.getIPAddressAndLocation();
    this.getDataFromServer();
    //this.bindModelDropDown();


    // console.log(JSON.stringify(DataService.get('Account')));

    // Defaults to 0 if no query param provided.

    this.lookupService.getAllLookups().subscribe(lookupResponse => {
      DataService.set('Lookups', lookupResponse);
      this.lookupService.saveLookups(lookupResponse);
      this.Lookups.IdentifierLkp = this.lookupService.getLookupByType('ID Type');
      this.idLkpsArray = this.Lookups.IdentifierLkp.filter(x => ['CNIC', 'FORMB'].includes(x.HiddenValue)).map(y => y.LookupId);
      this.idLkpsArrayPlace = this.Lookups.IdentifierLkp.filter(x => ['PASSPORT'].includes(x.HiddenValue)).map(y => y.LookupId);
      this.Lookups.TitleLkp = CommonHelper.OrderArrayByProperty(this.lookupService.getLookupByType('TITLES'), ['SortOrder'], ['asc']);
      this.Lookups.YesNo = this.lookupService.getLookupByType('YES_NO_BIT');
      this.Lookups.CustomerRelationshipLkp = this.lookupService.getLookupByType('CUSTOMER_RELATIONSHIP').filter(x => x.IsActive == 1);
      this.Lookups.AccountOperationLkp = this.lookupService.getLookupByType('ACCOUNT_KIND').filter(x => x.IsActive == 1);
      this.Lookups.Y_N = this.lookupService.getLookupByType('Y_N');
      this.Lookups.City = this.lookupService.getLookupByType('Expected Geographies City');
      this.Lookups.Branch = this.lookupService.getLookupByType('Expected Geographies City');
      this.Lookups.UserType = this.lookupService.getLookupByType('ID Type');
      this.Lookups.Devices = this.lookupService.getLookupByType('ID Type');
      this.Lookups.UsersRolesLov = this.lookupService.getLookupByType('ID Type');
      this.Lookups.ReportingUser = this.lookupService.getLookupByType('ID Type');
      this.Lookups.DesignationsLookup = this.lookupService.getLookupByType('DESIGNATION');
      this.Lookups.PurposeOfRelationshipLkp = this.lookupService.getLookupByType('PURPOSE_OF_ACCOUNT');
      this.Lookups.AccountTypeLkp = this.lookupService.getLookupByType('ID Type');
      this.Lookups.EStatementFrequencyLkp = this.lookupService.getLookupByType('ESTATEMENT_FREQUENCY');
      this.Lookups.Residences = CommonHelper.OrderArrayByProperty(this.lookupService.getLookupByType('COUNTRIES'), ['VisibleValue'], ['asc']);
      this.Lookups.MonthlyCreditTransactionsLkp = this.lookupService.getLookupByType('YES_NO_BIT');
      this.Lookups.MonthlyCreditTurnoverLkp = this.lookupService.getLookupByType('YES_NO_BIT');
      this.Lookups.NationalityLkp = this.lookupService.getLookupByType('YES_NO_BIT');
      this.Lookups.CountryOfResidenceLkp = this.lookupService.getLookupByType('YES_NO_BIT');
      this.Lookups.GenderLkp = this.lookupService.getLookupByType('GENDER');
      this.Lookups.ResidentStatusLkp = this.lookupService.getLookupByType('DAO_RESIDENT_STATUS').filter(x => x.IsActive == 1);
      this.Lookups.OccupationLkp = this.lookupService.getLookupByType('FORM_OCCUPATIONS');
      this.Lookups.ProfessionLkp = this.lookupService.getLookupByType('OCCUPATIONS');
      this.Lookups.IncomeSource = this.lookupService.getLookupByType('SOURCE_OF_INCOME');
      this.Lookups.AddressTypes = this.lookupService.getLookupByType('ADDRESS_TYPE');
      this.Lookups.DocumentTypes = this.lookupService.getLookupByType('IdentificationDocumentTypes');
      this.Lookups.JobTitle = this.lookupService.getLookupByType('JOB_TITLE');
      this.Lookups.AccountTypes = this.lookupService.getLookupByType('DAO_ACCOUNT_TYPE');


      this.Lookups.RACProductType = this.lookupService.getLookupByType('RAC_PRODUCT_TYPE');
      this.Lookups.CarType = this.lookupService.getLookupByType('CAR_TYPE');
      this.Lookups.BookingType = this.lookupService.getLookupByType('BOOKING_TYPE');
      this.Lookups.LoanTenure = this.lookupService.getLookupByType('LOAN_TENURE');
      this.Lookups.InsuranceCompany = this.lookupService.getLookupByType('INSURANCE_COMPANY');
      this.Lookups.TrackerAvailability = this.lookupService.getLookupByType('TRACKER_AVAILABILITY');
      this.filteredTrackerList = this.Lookups.TrackerAvailability;
      this.Lookups.RelationWithApplicant = this.lookupService.getLookupByType('RELATION_WITH_APPLICANT');
      this.Lookups.RelationWithNominee = this.lookupService.getLookupByType('RELATION_WITH_NOMINEE');
      this.Lookups.EmploymentDetails = this.lookupService.getLookupByType('EMPLOYMENT_DETAILS');
      this.Lookups.MakeModel = this.lookupService.getLookupByType('MAKE_MODEL');


      //RAG Lookups
      this.Lookups.LoanType = this.lookupService.getLookupByType('RAG_LOAN_TYPE');
      this.Lookups.PricingMarkupType = this.lookupService.getLookupByType('RAG_PRICING_MARKUP_TYPE');
      this.Lookups.ApplicationType = this.lookupService.getLookupByType('RAG_APPLICATION_TYPE');
      this.Lookups.LoanTenure = this.lookupService.getLookupByType('RAG_LOAN_TENURE');
      this.Lookups.RAGProductType = this.lookupService.getLookupByType('RAG_PRODUCT_TYPE');
      this.Lookups.PropertyType = this.lookupService.getLookupByType('PROPERTY_TYPE');
      this.Lookups.OPPropertyType = this.lookupService.getLookupByType('OP_PROPERTY_TYPE');
      this.Lookups.PropertyToBuy = this.lookupService.getLookupByType('PROPERTY_TO_BUY');
      this.Lookups.GMSSTier = this.lookupService.getLookupByType('GMSS_TIER');
      this.Lookups.PropertyDeveloperName = this.lookupService.getLookupByType('PROPERTY_DEVELOPER_NAME');
      this.Lookups.PBSPropertyDeveloperName = this.lookupService.getLookupByType('PBS_PROPERTY_DEVELOPER_NAME');
      this.Lookups.OPPropertyDeveloperName = this.lookupService.getLookupByType('OP_PROPERTY_DEVELOPER_NAME');
      this.Lookups.MeasurementUnit = this.lookupService.getLookupByType('MEASUREMENT_UNIT');
      this.Lookups.LandArea = this.lookupService.getLookupByType('LAND_AREA');
      this.Lookups.CoveredArea = this.lookupService.getLookupByType('COVERED_AREA');
      this.Lookups.PropertyOwnership = this.lookupService.getLookupByType('PROPERTY_OWNERSHIP');
      this.Lookups.DocumentType = this.lookupService.getLookupByType('DOCUMENT_TYPE');
      this.Lookups.PaymentType = this.lookupService.getLookupByType('PAYMENT_TYPE');
      this.Lookups.InstallmentPlan = this.lookupService.getLookupByType('INSTALLMENT_PLAN');
      this.Lookups.PSOptions = this.lookupService.getLookupByType('PAYMENT_BY_SELF_OPTIONS');
      this.Lookups.BankName = this.lookupService.getLookupByType('BANK_NAME');
      this.Lookups.Countries = this.lookupService.getLookupByType('COUNTRIES');
      this.LookupForDeclaration = this.Lookups;
      this.AppNumber = this.route.snapshot.paramMap.get('id');
    if(this.AppNumber) {
      this.loaderService.start();
      var searchReq = {
          AccountApplicationNumber: this.AppNumber,
          Status: "SendToCustomer"
        };
      this.applicationService.readApplicationByAccountNumberAndStatus(searchReq).toPromise().
      then(resInner => {
        if (resInner && resInner.data != null && resInner.status && resInner.status.code == '200'){
          DataService.set('Account', resInner.data.TmxCustomerMaster[0]);
          DataService.set('IsOld','1');
          DataService.set('Checklist', resInner.data.TmxLoanApplicationChecklist);
          DataService.set('data',resInner.data);
          this.UserId = resInner.data.UserId;
          this.ProcessId = resInner.data.ProcessInstanceId;
          this.AccountAppId = resInner.data.AccountApplicationId;
          this.PBSReadOnly = true;
          this.theCheckboxPSC = true;
          this.theCheckboxPSC2 = true;
          this.theCheckboxPSC3 = true;
          if (DataService.get('Account')) {
          this.setModelFromData(DataService.get('Account'));
          this.postDataLoadFunction();
          this.ShowPartialSubmitDeclaration=true;
            }
            else {
              this.createEmptyModel();
              this.PBSReadOnly = false;
            }
        }
        else {
          this.PBSReadOnly = false;
          this.showError("Application not found.");
          this.router.navigate(['/accountOpening']);
        }
        this.loaderService.stop();
      });

    }
  else {
    if (DataService.get('Account')) {
      this.setModelFromData(DataService.get('Account'));
      this.postDataLoadFunction()
    }
    else {
      this.createEmptyModel();

    }
  }
    });




}
  postLookupBindings(): void {




  }
  showError(message: string) {
    //this.toastr.error(message);
    this.dialog.open(DaoDialogComponent, {
      data: {
        title: 'Error',
        message: message,
        type: 'error'
      }
    });
  }
  postDataLoadFunction() {
    if (this.accountAppModel['PurposeOfAccountOneUDF']) {
      this.addPurposeOne = true;
    }

    if (this.accountAppModel['PurposeOfAccountTwoUDF']) {
      this.addPurposeTwo = true;
    }


    this.ApplicantCount = this.applicantDetails.length;
    this.CoApplicantNomineeCount = this.coApplicantNomineeDetails.length;

  }

  ngAfterViewInit() {

    // this.MyProp.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });

  }
  ngOnInit() {

    this.firebase.logEvent('Navigation | Basic Account Details');
    this.accountAppModel.EmailAddress = DataService.get('emailAddress');
    if(this.accountAppModel.EmailUDF)
        {this.firebase.setUserProp({Email: DataService.get('emailAddress')});}
    this.breakpointObserver
    .observe([Breakpoints.Small, Breakpoints.HandsetPortrait])
    .subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.smallScreen = true;
      }
      else
      {
        this.smallScreen = false;
      }
    });

    this.breakpointObserver
    .observe(['(min-width: 768px)'])
    .subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.xSmallScreen = true;
      }
      else
      {
        this.xSmallScreen = false;
      }
    });

    DataService.set('isLanding', false);

  }
  async GenerateOtp() {


    const searchRequest = {};
    searchRequest['Email'] = this.accountAppModel.EmailAddress;
    this.ngxService.start();
    await this.applicationService.GetOTP(searchRequest).toPromise().
      then(async res => {
        this.ngxService.stop();

        if (res  && res.status && res.status.code == '201') {
          this.firebase.logEvent('Action | OTP Generated');
          console.log(res.status.message);
          //this.router.navigate(['/home']);
          this.OtpGenerated = true;
          this.countStart = this.appConfig.AccessCodeExpiry;
          this.Otp = this.countStart;
          if (this.appConfig.env.toLowerCase() == 'dev') {
            this.accessCode = res.data;
            this.isDevEnv = true;
          }

        }

      }).catch(err => {
        this.ngxService.stop();
        console.log(err);
      });

    console.log('i m out');

  }

  async VerifyOtp() {

    this.ngxService.start();
    DataService.delete('emailAddress');
    DataService.delete('Account');


    const searchRequest = {};
    searchRequest['Email'] = this.accountAppModel.EmailAddress;
    searchRequest['OTP'] = this.otp;

    await this.applicationService.VerifyOTP(searchRequest).toPromise().
      then(async res => {
        if (res && res.data != null && res.status && res.status.code == '200') {
          console.log(res.status.message);
          this.OtpVerified = true;

        }
        else {
          this.ngxService.stop();
          this.showError("Invalid OTP, Please try again.");
          this.Otp = 0;
          return true;
        }

      }).catch(err =>
        console.log(err));
  }

  async postDetails(event: string, doInBackground = false) {
    if(this.ShowPartialSubmitDeclaration && this.PaymentBySelf) {
      let validationResult = this.performValidationsForSubmit();
        if (!validationResult) {
          return;
        }
      this.loaderService.start();
      this.bindAccountAppModel();
      var CommonModel = {
          Command: "SendToCIU",
          UserId: this.UserId,
          ProcessID: this.ProcessId,
          ApplicationId: this.AccountAppId
        };

        if (this.accountModel['AccountApplicationId']) {
        if(DataService.get('data'))
        this.setIds(DataService.get('data'));
        if(!this.accountModel.UserId) {
          this.accountModel.UserId = this.UserId;
        }
        await this.applicationService.updateApplication(this.accountModel).toPromise()
          .then(async res => {


            if (res && res.status && res.status.code == '200') {
              this.firebase.logEvent('Action | Saved for submussion Successfully');
              this.applicationService.executeWF(CommonModel).toPromise().
              then(resInner => {
                if (resInner && resInner.status && resInner.status.code == '200'){
                  let dialogRef = this.dialog.open(DaoDialogComponent, {
                    data: {
                      title: 'Application Submitted',
                      message: `Application number <b>${this.AppNumber}.</b> has been submitted successfully for further processing.`,
                      type: 'success'
                    }
                  });
                  this.firebase.logEvent('Action | Application Submitted Successfully');
                  //this.toastr.success('Application Updated Successfully with Application Number' + ' ' + res.data.AccountApplicationNumber);
                  dialogRef.afterClosed().subscribe(result => {
                    this.allowExit = true;
                    window.location.href = this.appConfig.LandingPageUrl;
                    //this.router.navigate(['../accountOpening']);
                  });
                }
                else {
                  this.showError("Could not submit application. Please try again");
                }
                this.loaderService.stop();
              });
            }
            else {
              this.saveInProgress = false;
              this.loaderService.stop();
              this.toastr.error(res.status.message);
              this.router.navigate(['/accountOpening']);
            }
          })
          .catch(err => {
                this.saveInProgress = false;
                this.loaderService.stop();
                this.toastr.error(err.error.Message);
                this.router.navigate(['/accountOpening']);
                return;
              });
        }

    }
    else {
      event = event.toLowerCase();
      if (event == 'submit') {
        let validationResult = this.performValidationsForSubmit();
        if (!validationResult) {
          return;
        }
      } else {
        if (this.saveInProgress && doInBackground) {
          return;
        } else {
          this.saveInProgress = true;
        }
      }
      this.bindAccountAppModel();
      if (!doInBackground) {
        this.loaderService.start();
      }
      if (this.accountModel['AccountApplicationId']) {
        if(DataService.get('data'))
        this.setIds(DataService.get('data'));
        await this.applicationService.updateApplication(this.accountModel).toPromise()
          .then(async res => {
            this.saveInProgress = false;

            if (res && res.status && res.status.code == '200') {
              if (event == 'save') {
                this.loaderService.stop();
                if (doInBackground) {
                  this.setIds(res.data);
                  return;
                }
                this.firebase.logEvent('Action | Application Saved and Exited');
                let dialogRef = this.dialog.open(DaoDialogComponent, {
                  data: {
                    title: 'Application Saved',
                    message: `Application has been saved with application number <b>${res.data.AccountApplicationNumber}.</b>
                    Please save this number to reference your application in future.`,
                    type: 'success'
                  }
                });
                //this.toastr.success('Application Updated Successfully with Application Number' + ' ' + res.data.AccountApplicationNumber);
                dialogRef.afterClosed().subscribe(result => {
                  this.allowExit = true;
                  window.location.href = this.appConfig.LandingPageUrl;
                  //this.router.navigate(['../accountOpening']);
                });



                return;
              }
              else if (event == 'submit') {
                //this.loaderService.start();
                await this.applicationService.initiateWF(this.accountModel).toPromise()
                  .then(async response => {
                    this.saveInProgress = false;

                    this.loaderService.stop();
                    let dialogRef = this.dialog.open(DaoDialogComponent, {
                      data: {
                        title: 'Application Submitted',
                        message: `Application number <b>${res.data.AccountApplicationNumber}.</b> has been submitted successfully for further processing.`,
                        type: 'success'
                      }
                    });
                    this.firebase.logEvent('Action | Application Submitted Successfully');
                    //this.toastr.success('Application Updated Successfully with Application Number' + ' ' + res.data.AccountApplicationNumber);
                    dialogRef.afterClosed().subscribe(result => {
                      this.allowExit = true;
                      window.location.href = this.appConfig.LandingPageUrl;
                      //this.router.navigate(['../accountOpening']);
                    });
                    //return;
                  }).catch(err => {
                    this.saveInProgress = false;


                    this.loaderService.stop();
                    this.toastr.error(err.error.Message);
                    this.router.navigate(['/accountOpening']);
                    return;
                  }
                  );
              }
            }
            else {
              this.toastr.error('An error occurred while processing your application, please contact support team for further details.');
              return;
            }
          }).catch(err => {
            this.saveInProgress = false;
            this.loaderService.stop();
            this.toastr.error('An error occurred while processing your application, please contact support team for further details.');
            console.log(err);
            // this.router.navigate(['/accountOpening']);
            return;
          });
      }
      else {
        await this.applicationService.postApplication(this.accountModel).toPromise()
          .then(async res => {
            this.saveInProgress = false;
            //this.loaderService.stop();
            if (res && res.status && res.status.code == '201') {
              if (event == 'save') {
                if (doInBackground) {
                  this.setIds(res.data);
                  return;
                }
                this.loaderService.stop();
                let dialogRef = this.dialog.open(DaoDialogComponent, {
                  data: {
                    title: 'Application Saved',
                    message: `Application has been saved with application number <b>${res.data.AccountApplicationNumber}.</b>
                    Please save this number to reference your application in future.`,
                    type: 'success'
                  }
                });
                this.firebase.logEvent('Action | Application saved and exited');
                dialogRef.afterClosed().subscribe(result => {
                  this.allowExit = true;
                  window.location.href = this.appConfig.LandingPageUrl;
                  //this.router.navigate(['../accountOpening']);
                });
                //this.toastr.success('Application Created Successfully with Application Number' + ' ' + res.data.AccountApplicationNumber);
                this.setModelFromData(res.data);
                return;
              }
              else {
                await this.applicationService.initiateWF(res.data).toPromise()
                  .then(async response => {
                    this.loaderService.stop();
                    this.firebase.logEvent('Action | Application Submitted Successfully');
                    let dialogRef = this.dialog.open(DaoDialogComponent, {
                      data: {
                        title: 'Application Submitted',
                        message: `Application number <b>${res.data.AccountApplicationNumber}.</b> has been submitted successfully for further processing.`,
                        type: 'success'
                      }
                    });

                    //this.toastr.success('Application Updated Successfully with Application Number' + ' ' + res.data.AccountApplicationNumber);
                    dialogRef.afterClosed().subscribe(result => {
                      this.allowExit = true;
                      window.location.href = this.appConfig.LandingPageUrl;
                      //this.router.navigate(['../accountOpening']);
                    });
                  }).catch(err => {
                    this.toastr.error(err);
                    //this.router.navigate(['/accountOpening']);
                    return;
                  }
                  );
              }
            }
            else {
              this.toastr.error('An error occurred while processing your application, please contact support team for further details.');

              //this.toastr.error('Application can not be created');
              return;
            }
          }).catch(err => {
            this.saveInProgress = false;
            this.loaderService.stop();
            this.toastr.error('An error occurred while processing your application, please contact support team for further details.');
            console.log(err);
            //this.router.navigate(['/accountOpening']);
            return;
          });
      }
    }
  }

  getNewApplicantDetailObject(): applicantDetailsModel {

    let app = {
      FatherSpouseName: '', CoApplicantName: '', Cnic: '', ContactNumberPak: '', RelationWithApplicant: '',CODisclaimer:'',
      IncomeClubbedWithCoApplicant: '', OtherRelation:'',LookupType:this.Lookups.Countries.filter(x=> x.HiddenValue != "PK")
    } as applicantDetailsModel;
    app.panelExpanded = true;

    return app;
  }
  addBankDetail(event) {
    event.stopPropagation();
    if (!this.accountAppModel['TmxCustomerRelationship']) {
      this.accountAppModel['TmxCustomerRelationship'] = [];
    }
    this.accountAppModel['TmxCustomerRelationship'].push(new BankDetailsModel());
  }



  addApplicant(event: Event,j: Number) {
    this.ApplicantCount++;
    this.applicantDetails.push(this.getNewApplicantDetailObject());
    //this.declarationsComponent.appDetails = this.applicantDetails;


    event.preventDefault();

  }
  ShowSingleApplicant(event: Event) {
    this.ShowApplicant = true;


    event.preventDefault();

  }
  addCoApplicantNominee(event: Event,j: Number) {
    event.preventDefault();

    this.CoApplicantNomineeCount++;
    this.coApplicantNomineeDetails.push(this.getNewApplicantDetailObject());

  }
  removeApplicantDetail(event: Event, index) {
    this.ApplicantCount--;
    if ((this.applicantDetails && this.applicantDetails.length > 1) || this.LienBased) {
      this.applicantDetails.splice(index, 1);

    }

    else{
      this.toastr.error("Atleast one applicant is mandatory.");
    }
    //this.declarationsComponent.appDetails = this.applicantDetails;

    event.preventDefault();

  }
  removeCoApplicantNomineeDetail(event: Event, index) {
    this.CoApplicantNomineeCount--;
    //if (this.coApplicantNomineeDetails && this.coApplicantNomineeDetails.length > 1) {
      this.coApplicantNomineeDetails.splice(index, 1);
    //}
    // else {
    //   this.toastr.error("Atleast one applicant is mandatory.");
    // }

    event.preventDefault();

  }


  docTypeSelected(selectedIdLkp, idItem) {

    if (selectedIdLkp) {
      let selectedLookup = this.Lookups.IdentifierLkp.find(x => x.LookupId == selectedIdLkp);
      if (selectedLookup && selectedLookup.HiddenValue) {
        if(['cnic','nicop', 'poc', 'scnic'].includes(selectedLookup.HiddenValue.toLowerCase())){
          idItem.type="number";
        } else {
          idItem.type = null;
        }
        if (['cnic', 'arc', 'formb', 'nadra.token', 'nara', 'nicop', 'poc', 'scnic'].includes(selectedLookup.HiddenValue.toLowerCase())) {
          idItem.minLength = 13;
          idItem.maxLength = 13;
          return;
        }
        else if (['passport'].includes(selectedLookup.HiddenValue.toLowerCase())) {
          idItem.minLength = 7;
          idItem.maxLength = 10;
          return;
        }
        else if (['ntn'].includes(selectedLookup.HiddenValue.toLowerCase())) {
          idItem.minLength = 9;
          idItem.maxLength = 9;
          return;
        }
      }
    }
    else {
      idItem.NationalIdentifierValue = null;
    }

    idItem.minLength = 0;
    idItem.maxLength = 30;
    // this.idLength = 30;
  }
  getDataFromServer() {

    //this.bindModelDropDown();

    this.lookupService.getBranchesLookups().subscribe(lookupResponse => {
      DataService.set('Branches', lookupResponse);
      this.lookupService.saveBranchesLookups(lookupResponse.data);
      this.filterCitiesAndBranches();
    });
  }
  getIPAddressAndLocation() {
    this.baseService.GetIPData().subscribe(data => {
      console.log('Geting IP and Locatiion '+data);
      if (data) {
        this.accountAppModel["IPAddress"] = data.ip;
        this.accountAppModel["IPLocation"] = `${data.city} ${data.country_name}`;
      }
      else {
        this.accountAppModel["IPAddress"] = "N/A";
        this.accountAppModel["IPLocation"] = "N/A";
      }
    });
    }



  createEmptyModel() {
    this.accountAppModel['TmxCustomerMaster'] = [];
    this.accountAppModel['TmxCustomerMaster'][0] = {};
    this.accountAppModel['EmailUDF'] = DataService.get('emailAddress');
    this.accountAppModel['UseMobileNumberAsUsername'] ="0";

  }
  filterCitiesAndBranches() {
    let uniqueCities = new Set(this.lookupService.Brancheslookups.map(x => x.CityName));
    this.cityList = Array.from(uniqueCities).map(city => ({ VisibleValue: city, LookupId: city }));
  }
  onCitySelected(city) {
    this.filteredBranchList= this.lookupService.Brancheslookups.filter(x => x.CityName == city).map(branch => ({ VisibleValue: branch.BranchName, LookupId: branch.CompanyBranchId }));
    console.log(city);
  }

  onPropertyOwnershipSelected(make) {


    if(this.Lookups.PropertyOwnership.filter(x => x.LookupId == make).map(y=>y.HiddenValue) == 'Applicant/RDA  Holder'){
      this.Disclaimer = '*You may have to visit Pakistan at time of transaction / property transfer';
    }else if (this.Lookups.PropertyOwnership.filter(x => x.LookupId == make).map(y=>y.HiddenValue) == 'Co-Applicant'){
      this.Disclaimer = '*The property will be transferred in the name of the co-applicant';
    }else{
      this.Disclaimer = '';
    }
    console.log(make);


  }

  onDeveloperSelected(make) {


    if(this.Lookups.PropertyDeveloperName.filter(x => x.LookupId == make).map(y=>y.HiddenValue) == 'Individual'){
      this.Individual = true;
      this.OtherDeveloper =false;
    }else if (this.Lookups.PropertyDeveloperName.filter(x => x.LookupId == make).map(y=>y.HiddenValue) == 'Other Builder/Developer'){
      this.OtherDeveloper =true;
      this.Individual = false;
    }else{
      this.OtherDeveloper =false;
      this.Individual = false;
    }
    console.log(make);


  }

  onDeveloperSelected1(make) {


    if(this.Lookups.PBSPropertyDeveloperName.filter(x => x.LookupId == make).map(y=>y.HiddenValue) == 'Individual'){
      this.Individual1 = true;
      this.OtherDeveloper1 =false;
    }else if (this.Lookups.PBSPropertyDeveloperName.filter(x => x.LookupId == make).map(y=>y.HiddenValue) == 'Other Builder/Developer'){
      this.OtherDeveloper1 =true;
      this.Individual1 = false;
    }else{
      this.OtherDeveloper1 =false;
      this.Individual1 = false;
    }
    console.log(make);


  }

  OnIncomeClubbed(make,index) {


    if(this.Lookups.Y_N.filter(x => x.LookupId == make).map(y=>y.HiddenValue) == 'Y'){
      this.applicantDetails[index].LookupType = this.Lookups.Countries.filter(x=> x.HiddenValue != "PK");
      this.applicantDetails[index].CODisclaimer= '*Co-borrower must be NRP';
    }else{
      this.applicantDetails[index].LookupType = this.Lookups.Countries;
      this.applicantDetails[index].CODisclaimer = '*Co-borrower must be NRP';
    }
    console.log(make);

    if(this.applicantDetails.filter(x=> x.IncomeClubbedWithCoApplicant == this.Lookups.Y_N.filter(x => x.HiddenValue == 'N').map(y=> y.LookupId)).length > 0) {
      this.BorrowerDocsRequired = true;
    }
    else {
      this.BorrowerDocsRequired = false;
    }

  }

  onPSOptionSelected(value) {
    if(value) {
      if(this.Lookups.PSOptions.filter(x => x.LookupId == value).map(y=>y.HiddenValue) != '1'){
        this.ShowSPADoc = true;
      }else{
        this.ShowSPADoc = false;
      }

    }
    else {
      this.ShowSPADoc = false;

    }
  }
  onPSOptionSelectedLien(value) {

    if(value) {
      if(this.Lookups.PSOptions.filter(x => x.LookupId == value).map(y=>y.HiddenValue) != '1'){
        this.ShowSPADocLien = true;
      }else{
        this.ShowSPADocLien = false;
      }
      if(this.Lookups.PSOptions.filter(x => x.LookupId == value).map(y=>y.HiddenValue) == '2'){//if nominate a family member

        this.ShowCoapplicantLien = true;
      }
      else{
        this.ShowCoapplicantLien = false;
      }
      if(this.Lookups.PSOptions.filter(x => x.LookupId == value).map(y=>y.HiddenValue) == '3'){//if nominate a law firm

        this.ShowNomineeLien = true;
        this.CoApplicantNomineeCount++;
        this.coApplicantNomineeDetails.push(this.getNewApplicantDetailObject());
      }
      else{
        this.ShowNomineeLien = false;
        this.CoApplicantNomineeCount=0;
        this.coApplicantNomineeDetails=[];
      }
    }
    else {
      this.ShowSPADocLien = false;
      this.ShowNomineeLien =false;
      this.ShowCoapplicantLien=false;
    }
  }

  onTierChange(tier){
    if(this.Lookups.GMSSTier.filter(x => x.LookupId == tier).map(y=>y.HiddenValue) == 'Tier-1'){
      this.maxFin = 2700000;
      this.maxPropertySize = 125;
      this.maxCoveredArea = 850;
    }else if(this.Lookups.GMSSTier.filter(x => x.LookupId == tier).map(y=>y.HiddenValue) == 'Tier-2'){
      this.maxFin = 6000000;
      this.maxPropertySize = 125;
      this.maxCoveredArea = 1250;
    }else if(this.Lookups.GMSSTier.filter(x => x.LookupId == tier).map(y=>y.HiddenValue) == 'Tier-3'){
      this.maxFin = 10000000;
      this.maxPropertySize = 250;
      this.maxCoveredArea = 20000;
    }else{
      this.maxFin = 999999999;
      this.maxPropertySize = 999999;
      this.maxCoveredArea = 999999;
    }
    this.onFinValueChange();
    console.log(tier);
  }
  onFinValueChange(){
    this.accountAppModel.PropertyValue = this.accountAppModel.ApproxPropertyValue;
    this.accountAppModel.OPPropertyValue = this.accountAppModel.ApproxPropertyValue;
    if(this.accountAppModel.FinancingAmount && this.accountAppModel.ApproxPropertyValue){

      if(parseInt(this.accountAppModel.FinancingAmount) > parseInt(this.accountAppModel.ApproxPropertyValue)){
        this.showError("Financing Amount can not be greater than Approximate Property Value : "+this.accountAppModel.ApproxPropertyValue);
        //inputFin.form.controls.FinancingAmount.setErrors({max:true});
        this.accountAppModel.FinancingAmount = null;
        this.IsManualValid = false;
      }else if(parseInt(this.accountAppModel.FinancingAmount) > this.maxFin){
        this.showError("Financing Amount can not be greater than : "+this.maxFin);
        //inputFin.form.controls.FinancingAmount.setErrors({max:true});
        this.accountAppModel.FinancingAmount = null;
        this.IsManualValid = false;
      }
      else{
        this.IsManualValid = true;
      }

    }
    if(this.accountAppModel.PropertySize){
      if(parseInt(this.accountAppModel.PropertySize) > this.maxPropertySize){
        this.showError("Property Size can not be greater than : "+this.maxPropertySize);
        //inputFin.form.controls.FinancingAmount.setErrors({max:true});
        this.accountAppModel.PropertySize = null;
        this.IsManualValid = false;
      }
      else{
        this.IsManualValid = true;
      }
    }

    if(this.accountAppModel.CoveredArea){
      if(parseInt(this.accountAppModel.CoveredArea) > this.maxCoveredArea){
        this.showError("Covered Area can not be greater than : "+this.maxCoveredArea);
        //inputFin.form.controls.FinancingAmount.setErrors({max:true});
        this.accountAppModel.CoveredArea = null;
        this.IsManualValid = false;
      }else{
        this.IsManualValid = true;
      }
    }

    this.calculateEquityContribution(0);
  }
  onPropertyToBuySelected(type) {

    if(this.Lookups.PropertyToBuy.filter(x => x.LookupId == type).map(y=>y.HiddenValue) == 'I Just want a limit approval now and will provide property details later'){
      this.JustLimitApprovalSelected = true;
    }
    else{
      this.JustLimitApprovalSelected = false;


    }

    if(type){
      this.filteredDevList= this.Lookups.PropertyDeveloperName.filter(x => x.ParentLookupId == type);

    }else{
      this.filteredDevList= this.Lookups.PropertyDeveloperName;
    }
    this.accountAppModel.PropertyDeveloperName = null;

  }
  calculateEquityContribution(value) {
    if(this.accountAppModel.OPEquityContribution && this.accountAppModel.OPPropertyValue) {
      var equity = parseInt(this.accountAppModel.OPEquityContribution)/100;
      var propertyValue = parseInt(this.accountAppModel.OPPropertyValue);
      this.accountAppModel.OPApplicantContribution = (propertyValue * equity);
      this.accountAppModel.OPBankContribution = (propertyValue * (1-equity));
    }
    else {
      this.accountAppModel.OPApplicantContribution = 0;
      this.accountAppModel.OPBankContribution = 0;
    }

  }
  numtowords(digits){
    this.accountAppModel.PaymentAmountInWords = converter.toWords(digits);
  }
  onPaymentTypeSelected(type) {

    if(this.Lookups.PaymentType.filter(x => x.LookupId == type).map(y=>y.HiddenValue) == 'Pay Order'){
      this.PayOrderSelected = true;
      this.AccountTransferSelected = false;
    }else if(this.Lookups.PaymentType.filter(x => x.LookupId == type).map(y=>y.HiddenValue) == 'Account Transfer'){
      this.AccountTransferSelected = true;
      this.PayOrderSelected = false;
    }
    else{
      this.PayOrderSelected = false;
      this.AccountTransferSelected = false;


    }
  }

  onPropertyValueChange(value){
    this.accountAppModel.PropertyValue = value;
  }
  onLoanTypeSelected(type) {
    this.onProductTypeSelected(this.accountAppModel.RAGProductType);
    this.onPSOptionSelectedLien(this.accountAppModel.PSOptionLien);
    if(this.Lookups.LoanType.filter(x => x.LookupId == type).map(y=>y.HiddenValue) == 'Payment by Self (Cash)'){
      this.PaymentBySelf = true;
      this.GMSSSelected = false;
      this.OPFinancing = false;
      this.filteredPricingMarkupType = this.Lookups.PricingMarkupType.filter(x => x.HiddenValue != 'Hybrid Rate');
    }else if(this.Lookups.LoanType.filter(x => x.LookupId == type).map(y=>y.HiddenValue) == 'G-MSS (GOP Markup Subsidee Scheme)'){
      this.GMSSSelected = true;
      this.PaymentBySelf = false;
      this.OPFinancing = false;
      this.filteredPricingMarkupType = this.Lookups.PricingMarkupType.filter(x => x.HiddenValue == 'Hybrid Rate');
      this.accountAppModel.PricingMarkupType = this.Lookups.PricingMarkupType.filter(x => x.HiddenValue == 'Hybrid Rate').map(x=> x.LookupId)[0];
    }
    else{
      if (this.Lookups.LoanType.filter(x => x.LookupId == type).map(y=>y.HiddenValue) == 'Off-Plan Financing') {
        this.OPFinancing = true;
      }else{
        this.OPFinancing = false;
      }
      this.PaymentBySelf = false;
      this.GMSSSelected = false;
      this.filteredPricingMarkupType = this.Lookups.PricingMarkupType.filter(x => x.HiddenValue != 'Hybrid Rate');

    }
    if(this.OPFinancing) {
      this.FilteredPropertyToBuy = this.Lookups.PropertyToBuy.filter(x=> x.VisibleValue != "I Just want a limit approval now and will provide property details later");
    }
    else {
      this.FilteredPropertyToBuy = this.Lookups.PropertyToBuy;
    }
    this.onPaymentBySelf.emit(this.PaymentBySelf);
  }
  onApplicationTypeSelected(type) {

    if(this.Lookups.ApplicationType.filter(x => x.LookupId == type).map(y=>y.HiddenValue) == 'Single'){
      this.Single = true;
      this.CoBorrower = false;
      if(this.Lookups.RAGProductType.filter(x => x.LookupId == this.accountAppModel.RAGProductType).map(y=>y.HiddenValue) == 'Lien based'){
        this.LienBased = true;
        this.ShowApplicant = false;
        this.applicantDetails = [];
        this.coApplicantNomineeDetails = [];
        this.CoApplicantNomineeCount=0;
        this.ApplicantCount = 0;
      }
      else{

        this.LienBased = false;
        this.applicantDetails.push(this.getNewApplicantDetailObject());
        this.ApplicantCount = 1;
        this.CoApplicantNomineeCount++;
        this.coApplicantNomineeDetails.push(this.getNewApplicantDetailObject());

      }
    }else if(this.Lookups.ApplicationType.filter(x => x.LookupId == type).map(y=>y.HiddenValue) == 'with Co-borrower (For Income Clubbing)'){
      this.CoBorrower = true;
      this.Single = false;
      this.applicantDetails=[];
      this.ApplicantCount = 0;
      this.applicantDetails.push(this.getNewApplicantDetailObject());
      this.ApplicantCount = 1;
    }
    else{
      this.Single = false;
      this.CoBorrower = false;
      this.applicantDetails=[];
      this.ApplicantCount = 0;

    }
  }
  onProductTypeSelected(type) {
    this.onPSOptionSelectedLien(this.accountAppModel.PSOptionLien);
    if(this.Lookups.RAGProductType.filter(x => x.LookupId == type).map(y=>y.HiddenValue) == 'Lien based'){
      this.accountAppModel.OPEquityContribution = 1;
      this.LienBased = true;
      this.applicantDetails=[];
      this.ApplicantCount = 0;
      this.applicantDetails.push(this.getNewApplicantDetailObject());
      this.ApplicantCount = 1;
    }else if(this.Lookups.RAGProductType.filter(x => x.LookupId == type).map(y=>y.HiddenValue) == 'Non-Lien based'){
      this.LienBased = false;
      this.applicantDetails=[];
      this.ApplicantCount = 0;
      this.applicantDetails.push(this.getNewApplicantDetailObject());
      this.ApplicantCount = 1;
    }
    else{
      this.accountAppModel.OPEquityContribution = 15;
      this.LienBased = false;

    }
  }
  onPropertyPropertyDeveloperNameSelected(type) {
    this.accountAppModel.OPBuilderLink = this.Lookups.OPPropertyDeveloperName.filter(x => x.LookupId == type).map(y=>y.Description);

  }
  BuilderLinkClicked() {
    window.location.href = this.accountAppModel.OPBuilderLink;
  }
  checkOtherRelationRequired(type) {

    if(this.Lookups.RelationWithNominee.filter(x => x.LookupId == type).map(y=>y.HiddenValue) == 'Others'){
      return true;
    }
    else{
      return false;
    }
  }
  checkOtherEmploymentRequired(value) {
    if (value) {
      if (this.Lookups.EmploymentDetails.filter(x => x.LookupId == value).map(y => y.HiddenValue) == '3') {
        return true;
      }
      else {
        return false;
      }
    }
  }
  checkCompanyNameRequired(value) {
    if (value) {
      var selectedRelation = this.Lookups.RelationWithNominee.filter(x => x.LookupId == value).map(y => y.HiddenValue);
      if ( selectedRelation == 'Lawyer' || selectedRelation == 'Dealer') {
        return true;
      }
      else {
        return false;
      }
    }
  }

  saveit(){
    // the url,html tag should be called from here , how ?
    window.open("../../assets/tnc/calc.xlsx");
    }
  onEmploymentSelected(emp) {
    if(emp == '94885'){//if salaried
      this.Salaried = true;
      this.SelfEmployed = false;
      this.Other = false;
    console.log(emp);
    }else if (emp == '94886'){ //if self employeed
      this.SelfEmployed = true;
      this.Salaried = false;
      this.Other = false;
    }
    else if (emp =='94887'){//others
      this.Salaried = false;
      this.SelfEmployed = false;
      this.Other = true;
    }
    else{
      this.Salaried = false;
      this.SelfEmployed = false;
      this.Other = false;
    }

  }

  bindModelDropDown() {
    // this.showSpinner = true;
    this.lookupService.getAllLookups().subscribe(lookupResponse => {
      DataService.set('Lookups', lookupResponse);
      this.lookupService.saveLookups(lookupResponse);
      this.Lookups.IdentifierLkp = this.lookupService.getLookupByType('ID Type');
      this.idLkpsArray = this.Lookups.IdentifierLkp.filter(x => ['CNIC', 'FORMB'].includes(x.HiddenValue)).map(y => y.LookupId);
      this.idLkpsArrayPlace = this.Lookups.IdentifierLkp.filter(x => ['PASSPORT'].includes(x.HiddenValue)).map(y => y.LookupId);
      this.Lookups.TitleLkp = CommonHelper.OrderArrayByProperty(this.lookupService.getLookupByType('TITLES'), ['SortOrder'], ['asc']);
      this.Lookups.YesNo = this.lookupService.getLookupByType('YES_NO_BIT');
      this.Lookups.CustomerRelationshipLkp = this.lookupService.getLookupByType('CUSTOMER_RELATIONSHIP').filter(x => x.IsActive == 1);
      this.Lookups.AccountOperationLkp = this.lookupService.getLookupByType('ACCOUNT_KIND').filter(x => x.IsActive == 1);
      this.Lookups.Y_N = this.lookupService.getLookupByType('Y_N');
      this.Lookups.City = this.lookupService.getLookupByType('Expected Geographies City');
      this.Lookups.Branch = this.lookupService.getLookupByType('Expected Geographies City');
      this.Lookups.UserType = this.lookupService.getLookupByType('ID Type');
      this.Lookups.Devices = this.lookupService.getLookupByType('ID Type');
      this.Lookups.UsersRolesLov = this.lookupService.getLookupByType('ID Type');
      this.Lookups.ReportingUser = this.lookupService.getLookupByType('ID Type');
      this.Lookups.DesignationsLookup = this.lookupService.getLookupByType('DESIGNATION');
      this.Lookups.PurposeOfRelationshipLkp = this.lookupService.getLookupByType('PURPOSE_OF_ACCOUNT');
      this.Lookups.AccountTypeLkp = this.lookupService.getLookupByType('ID Type');
      this.Lookups.EStatementFrequencyLkp = this.lookupService.getLookupByType('ESTATEMENT_FREQUENCY');
      this.Lookups.Residences = CommonHelper.OrderArrayByProperty(this.lookupService.getLookupByType('COUNTRIES'), ['VisibleValue'], ['asc']);
      this.Lookups.MonthlyCreditTransactionsLkp = this.lookupService.getLookupByType('YES_NO_BIT');
      this.Lookups.MonthlyCreditTurnoverLkp = this.lookupService.getLookupByType('YES_NO_BIT');
      this.Lookups.NationalityLkp = this.lookupService.getLookupByType('YES_NO_BIT');
      this.Lookups.CountryOfResidenceLkp = this.lookupService.getLookupByType('YES_NO_BIT');
      this.Lookups.GenderLkp = this.lookupService.getLookupByType('GENDER');
      this.Lookups.ResidentStatusLkp = this.lookupService.getLookupByType('DAO_RESIDENT_STATUS').filter(x => x.IsActive == 1);
      this.Lookups.OccupationLkp = this.lookupService.getLookupByType('FORM_OCCUPATIONS');
      this.Lookups.ProfessionLkp = this.lookupService.getLookupByType('OCCUPATIONS');
      this.Lookups.IncomeSource = this.lookupService.getLookupByType('SOURCE_OF_INCOME');
      this.Lookups.AddressTypes = this.lookupService.getLookupByType('ADDRESS_TYPE');
      this.Lookups.DocumentTypes = this.lookupService.getLookupByType('IdentificationDocumentTypes');
      this.Lookups.JobTitle = this.lookupService.getLookupByType('JOB_TITLE');
      this.Lookups.AccountTypes = this.lookupService.getLookupByType('DAO_ACCOUNT_TYPE');


      this.Lookups.RACProductType = this.lookupService.getLookupByType('RAC_PRODUCT_TYPE');
      this.Lookups.CarType = this.lookupService.getLookupByType('CAR_TYPE');
      this.Lookups.BookingType = this.lookupService.getLookupByType('BOOKING_TYPE');
      this.Lookups.LoanTenure = this.lookupService.getLookupByType('LOAN_TENURE');
      this.Lookups.InsuranceCompany = this.lookupService.getLookupByType('INSURANCE_COMPANY');
      this.Lookups.TrackerAvailability = this.lookupService.getLookupByType('TRACKER_AVAILABILITY');
      this.filteredTrackerList = this.Lookups.TrackerAvailability;
      this.Lookups.RelationWithApplicant = this.lookupService.getLookupByType('RELATION_WITH_APPLICANT');
      this.Lookups.RelationWithNominee = this.lookupService.getLookupByType('RELATION_WITH_NOMINEE');
      this.Lookups.EmploymentDetails = this.lookupService.getLookupByType('EMPLOYMENT_DETAILS');
      this.Lookups.MakeModel = this.lookupService.getLookupByType('MAKE_MODEL');


      //RAG Lookups
      this.Lookups.LoanType = this.lookupService.getLookupByType('RAG_LOAN_TYPE');
      this.Lookups.PricingMarkupType = this.lookupService.getLookupByType('RAG_PRICING_MARKUP_TYPE');
      this.Lookups.ApplicationType = this.lookupService.getLookupByType('RAG_APPLICATION_TYPE');
      this.Lookups.LoanTenure = this.lookupService.getLookupByType('RAG_LOAN_TENURE');
      this.Lookups.RAGProductType = this.lookupService.getLookupByType('RAG_PRODUCT_TYPE');
      this.Lookups.PropertyType = this.lookupService.getLookupByType('PROPERTY_TYPE');
      this.Lookups.OPPropertyType = this.lookupService.getLookupByType('OP_PROPERTY_TYPE');
      this.Lookups.PropertyToBuy = this.lookupService.getLookupByType('PROPERTY_TO_BUY');
      this.Lookups.GMSSTier = this.lookupService.getLookupByType('GMSS_TIER');
      this.Lookups.PropertyDeveloperName = this.lookupService.getLookupByType('PROPERTY_DEVELOPER_NAME');
      this.Lookups.PBSPropertyDeveloperName = this.lookupService.getLookupByType('PBS_PROPERTY_DEVELOPER_NAME');
      this.Lookups.OPPropertyDeveloperName = this.lookupService.getLookupByType('OP_PROPERTY_DEVELOPER_NAME');
      this.Lookups.MeasurementUnit = this.lookupService.getLookupByType('MEASUREMENT_UNIT');
      this.Lookups.LandArea = this.lookupService.getLookupByType('LAND_AREA');
      this.Lookups.CoveredArea = this.lookupService.getLookupByType('COVERED_AREA');
      this.Lookups.PropertyOwnership = this.lookupService.getLookupByType('PROPERTY_OWNERSHIP');
      this.Lookups.DocumentType = this.lookupService.getLookupByType('DOCUMENT_TYPE');
      this.Lookups.PaymentType = this.lookupService.getLookupByType('PAYMENT_TYPE');
      this.Lookups.InstallmentPlan = this.lookupService.getLookupByType('INSTALLMENT_PLAN');
      this.Lookups.PSOptions = this.lookupService.getLookupByType('PAYMENT_BY_SELF_OPTIONS');
      this.Lookups.BankName = this.lookupService.getLookupByType('BANK_NAME');
      this.Lookups.Countries = this.lookupService.getLookupByType('COUNTRIES');
      this.LookupForDeclaration = this.Lookups;

    });
  }
  fetchBranchList(data) {
    if (data['TmxCustomerMaster'][0].TmxCustomerDetail && data['TmxCustomerMaster'][0].TmxCustomerDetail[0] && data['TmxCustomerMaster'][0].TmxCustomerDetail[0].TmxPerson) {
      if (data['TmxCustomerMaster'][0].TmxCustomerDetail[0].TmxPerson.PersonCurrentCityUDF) {
        this.onCitySelected(data['TmxCustomerMaster'][0].TmxCustomerDetail[0].TmxPerson.PersonCurrentCityUDF);
      }
    }
  }
  formSubmit(form) {
    console.log(this.model);
    console.log(form);
  }
  performValidationsForSubmit() {
    let errorMessage: string = null;
    errorMessage = this.getValidationErrorMessage();
    if (CommonHelper.Exists(errorMessage)) {
      this.toastr.error(errorMessage, "Validation Failed", {
        timeOut: 6500
      });
      return false;
    }
    console.log(this.accountAppModel);
    console.log(this.documentAttachmentComponent);
    return true;

  }
  getValidationErrorMessage() {

    if (CommonHelper.Exists(this.accountAppModel, 'TmxLoanApplicationChecklist') ) {

    let attachedChecklists = this.accountAppModel['TmxLoanApplicationChecklist'].filter(x => x.uploaded || x.AttachmentURL).map(x => '' + x.LoanProductChecklistId);// convert to string Jugar
    let documentGroupsToValidate = Array.from(new Set(this.documentAttachmentComponent.Checklists.filter(x => x.group != 'Optional').map(x => x.group)));
    for (let i = 0; i < documentGroupsToValidate.length; i++) {
      var docGroup = documentGroupsToValidate[i];
      let documentIds = this.documentAttachmentComponent.Checklists.filter(x => x.group == docGroup).map(x => x.id);
      let docFound = documentIds.some(x => attachedChecklists.includes('' + x));
      if (!docFound) {
        return `Supporting documents not found for ${docGroup}`;
      }
    };
  }else{
    return null;
  }


  }



  async readAccountApplication(searchRequest) {
    this.loaderService.start();
    await this.applicationService.readApplication(searchRequest).toPromise()
      .then(response => {
        this.loaderService.stop();
        if (response && response.data) {
          // this.applicationService.readApplicationById(response.data.accountApplicationID).subscribe(res => {
          return response.data;

          // });
        }
      })
      .catch(async (error) => {
        this.loaderService.stop();
        console.log(error);
      });
  }
  bindAccountAppModel() {
    this.accountModel = this.accountAppModel;
    this.accountModel.AccountNumber = null;
    this.accountModel['TmxCustomerMaster'] = [];
    this.accountModel["TmxApplicationDetail"] = [];
    this.accountModel["TmxApplicationDetail"][0] = {};
    this.accountModel["TmxApplicationDetail"][0].UseMobileNumberAsUsername ="0";

     this.accountModel['TmxLoanApplicationChecklist'] = [];
    // this.accountModel['TmxLoanApplicationChecklist'] = this.accountAppModel['TmxLoanApplicationChecklist'];
    this.accountModel['TmxCustomerMaster'][0] = {};
    this.accountModel['TmxCustomerMaster'][0].TmxApplicantDetail = [];
    if(this.applicantDetails.length !=0 ){
      this.accountModel['TmxCustomerMaster'][0].TmxApplicantDetail =  this.applicantDetails;
    }
    this.accountModel['TmxCustomerMaster'][0].TmxCoApplicantNomineeDetail = [];
    if(this.coApplicantNomineeDetails.length !=0 ){
      this.accountModel['TmxCustomerMaster'][0].TmxCoApplicantNomineeDetail =  this.coApplicantNomineeDetails;
    }
    this.accountModel['ProductId'] = this.appConfig.ProductId; // hardcoded for demo 90
    this.accountModel['TmxCustomerMaster'][0].IPAddress=this.accountAppModel["IPAddress"];
    this.accountModel['TmxCustomerMaster'][0].IPLocation=this.accountAppModel["IPLocation"];
    this.accountModel['TmxCustomerMaster'][0].RefNo = DataService.get("RefNo");
    this.accountModel['TmxCustomerMaster'][0].PaymentBySelf = this.PaymentBySelf;
    this.accountModel['TmxCustomerMaster'][0].PayOrderSelected = this.PayOrderSelected;

    if(this.lookupService.Brancheslookups.filter(br=>br.BranchName == this.accountAppModel.Branch).map(br=>br.CompanyBranchId)){
      this.accountModel['CompanyBranchId'] = this.lookupService.Brancheslookups.filter(br=>br.BranchName == this.accountAppModel.Branch).map(br=>br.CompanyBranchId)[0];
    }else{
      this.accountModel['CompanyBranchId'] = this.appConfig.CompanyBranchId; // hardcoded for demo 1018
    }
    if (this.accountAppModel['EmailAddress']) {
      this.accountModel['TmxCustomerMaster'][0].EmailUDF = this.accountAppModel['EmailAddress'];
    }
    if (this.accountModel.AccountApplicationNumber) {
      this.accountModel['TmxCustomerMaster'][0].AccountNumber = this.accountModel.AccountApplicationNumber;

    }
    if (this.accountAppModel['PrimaryApplicantName']) {
      this.accountModel['TmxCustomerMaster'][0].PrimaryApplicantName = this.accountAppModel['PrimaryApplicantName'];
      this.accountModel['TmxCustomerMaster'][0].CustomerName = this.accountAppModel['PrimaryApplicantName'];
      this.accountModel['AccountName'] = this.accountAppModel['PrimaryApplicantName'];
    }

    if (this.accountAppModel['LoanType']) {
      this.accountModel['TmxCustomerMaster'][0].LoanType = this.accountAppModel['LoanType'];
    }
    if (this.accountAppModel['RAGProductType']) {
      this.accountModel['TmxCustomerMaster'][0].RAGProductType = this.accountAppModel['RAGProductType'];
    }
    if (this.accountAppModel['ApplicationType']) {
      this.accountModel['TmxCustomerMaster'][0].ApplicationType = this.accountAppModel['ApplicationType'];
    }
    if (this.accountAppModel['PricingMarkupType']) {
      this.accountModel['TmxCustomerMaster'][0].PricingMarkupType = this.accountAppModel['PricingMarkupType'];
    }
    if (this.accountAppModel['PropertyType']) {
      this.accountModel['TmxCustomerMaster'][0].PropertyType = this.accountAppModel['PropertyType'];
    }
    if (this.accountAppModel['PropertyToBuy']) {
      this.accountModel['TmxCustomerMaster'][0].PropertyToBuy = this.accountAppModel['PropertyToBuy'];
    }
    if (this.accountAppModel['ApproxPropertyValue']) {
      this.accountModel['TmxCustomerMaster'][0].ApproxPropertyValue = this.accountAppModel['ApproxPropertyValue'];
    }
    if (this.accountAppModel['FinancingAmount']) {
      this.accountModel['TmxCustomerMaster'][0].FinancingAmount = this.accountAppModel['FinancingAmount'];
    }
    if (this.accountAppModel['LoanTenure']) {
      this.accountModel['TmxCustomerMaster'][0].LoanTenure = this.accountAppModel['LoanTenure'];
    }
    if (this.accountAppModel['GMSSTier']) {
      this.accountModel['TmxCustomerMaster'][0].GMSSTier = this.accountAppModel['GMSSTier'];
    }
    if (this.accountAppModel['InstallmentAmount']) {
      this.accountModel['TmxCustomerMaster'][0].InstallmentAmount = this.accountAppModel['InstallmentAmount'];
    }
    if (this.accountAppModel['PropertyDeveloperName']) {
      this.accountModel['TmxCustomerMaster'][0].PropertyDeveloperName = this.accountAppModel['PropertyDeveloperName'];
    }
    if (this.accountAppModel['City']) {
      this.accountModel['TmxCustomerMaster'][0].City = this.accountAppModel['City'];
    }
    if (this.accountAppModel['PropertyValue']) {
      this.accountModel['TmxCustomerMaster'][0].PropertyValue = this.accountAppModel['PropertyValue'];
    }
    if (this.accountAppModel['PropertySize']) {
      this.accountModel['TmxCustomerMaster'][0].PropertySize = this.accountAppModel['PropertySize'];
    }
    if (this.accountAppModel['MeasurementUnit']) {
      this.accountModel['TmxCustomerMaster'][0].MeasurementUnit = this.accountAppModel['MeasurementUnit'];
    }
    if (this.accountAppModel['LandArea']) {
      this.accountModel['TmxCustomerMaster'][0].LandArea = this.accountAppModel['LandArea'];
    }
    if (this.accountAppModel['CoveredArea']) {
      this.accountModel['TmxCustomerMaster'][0].CoveredArea = this.accountAppModel['CoveredArea'];
    }
    if (this.accountAppModel['AddressLocationOfProperty']) {
      this.accountModel['TmxCustomerMaster'][0].AddressLocationOfProperty = this.accountAppModel['AddressLocationOfProperty'];
    }
    if (this.accountAppModel['AddressCity']) {
      this.accountModel['TmxCustomerMaster'][0].AddressCity = this.accountAppModel['AddressCity'];
    }
    if (this.accountAppModel['ExistingOwnerName']) {
      this.accountModel['TmxCustomerMaster'][0].ExistingOwnerName = this.accountAppModel['ExistingOwnerName'];
    }
    if (this.accountAppModel['ExistingEmailAddress']) {
      this.accountModel['TmxCustomerMaster'][0].ExistingEmailAddress = this.accountAppModel['ExistingEmailAddress'];
    }
    if (this.accountAppModel['ExistingOwnerMobile']) {
      this.accountModel['TmxCustomerMaster'][0].ExistingOwnerMobile = this.accountAppModel['ExistingOwnerMobile'];
    }

    if (this.accountAppModel['ExistingOwnerCnic']) {
      this.accountModel['TmxCustomerMaster'][0].ExistingOwnerCnic = this.accountAppModel['ExistingOwnerCnic'];
    }
    if (this.accountAppModel['Cnic']) {
      this.accountModel['TmxCustomerMaster'][0].Cnic = this.accountAppModel['Cnic'];
    }
    if (this.accountAppModel['PropertyOwnerShip']) {
      this.accountModel['TmxCustomerMaster'][0].PropertyOwnerShip = this.accountAppModel['PropertyOwnerShip'];
    }
    if (this.accountAppModel['CounteryName']) {
      this.accountModel['TmxCustomerMaster'][0].CounteryName = this.accountAppModel['CounteryName'];
    }
    if (this.accountAppModel['Address']) {
      this.accountModel['TmxCustomerMaster'][0].Address = this.accountAppModel['Address'];
    }
    if (this.accountAppModel['BusinessAddress']) {
      this.accountModel['TmxCustomerMaster'][0].BusinessAddress = this.accountAppModel['BusinessAddress'];
    }
    if (this.accountAppModel['ContactNumberOutsidePak']) {
      this.accountModel['TmxCustomerMaster'][0].ContactNumberOutsidePak = this.accountAppModel['ContactNumberOutsidePak'];
    }
    if (this.accountAppModel['EmailAddress']) {
      this.accountModel['TmxCustomerMaster'][0].EmailUDF = this.accountAppModel['EmailAddress'];
    }
    if (this.accountAppModel['EmployeeName']) {
      this.accountModel['TmxCustomerMaster'][0].EmployeeName = this.accountAppModel['EmployeeName'];
    }if (this.accountAppModel['EmployeeSince']) {
      this.accountModel['TmxCustomerMaster'][0].EmployeeSince = this.accountAppModel['EmployeeSince'];
    }
    if (this.accountAppModel['IsSalaried']) {
      this.accountModel['TmxCustomerMaster'][0].IsSalaried = this.accountAppModel['IsSalaried'];
    }
    if (this.accountAppModel['Salary']) {
      this.accountModel['TmxCustomerMaster'][0].Salary = this.accountAppModel['Salary'];
    }
    if (this.accountAppModel['NameOfBusiness']) {
      this.accountModel['TmxCustomerMaster'][0].NameOfBusiness = this.accountAppModel['NameOfBusiness'];
    }if (this.accountAppModel['StatusOfBusiness']) {
      this.accountModel['TmxCustomerMaster'][0].StatusOfBusiness = this.accountAppModel['StatusOfBusiness'];
    }if (this.accountAppModel['YearsInBusiness']) {
      this.accountModel['TmxCustomerMaster'][0].YearsInBusiness = this.accountAppModel['YearsInBusiness'];
    }if (this.accountAppModel['MonthlyIncome']) {
      this.accountModel['TmxCustomerMaster'][0].MonthlyIncome = this.accountAppModel['MonthlyIncome'];
    }

    if (this.accountAppModel['BeneficiaryName']) {
      this.accountModel['TmxCustomerMaster'][0].BeneficiaryName = this.accountAppModel['BeneficiaryName'];
    }
    if (this.accountAppModel['BuilderName1']) {
      this.accountModel['TmxCustomerMaster'][0].BuilderName1 = this.accountAppModel['BuilderName1'];
    }
    if (this.accountAppModel['BuilderName']) {
      this.accountModel['TmxCustomerMaster'][0].BuilderName = this.accountAppModel['BuilderName'];
    }
    if (this.accountAppModel['BuilderNTNNo']) {
      this.accountModel['TmxCustomerMaster'][0].BuilderNTNNo = this.accountAppModel['BuilderNTNNo'];
    }
    if (this.accountAppModel['BuilderNTNNo1']) {
      this.accountModel['TmxCustomerMaster'][0].BuilderNTNNo1 = this.accountAppModel['BuilderNTNNo1'];
    }
    if (this.accountAppModel['BuilderEmailAddress']) {
      this.accountModel['TmxCustomerMaster'][0].BuilderEmailAddress = this.accountAppModel['BuilderEmailAddress'];
    }
    if (this.accountAppModel['BuilderMobileNo']) {
      this.accountModel['TmxCustomerMaster'][0].BuilderMobileNo = this.accountAppModel['BuilderMobileNo'];
    }
    if (this.accountAppModel['BuilderEmailAddress1']) {
      this.accountModel['TmxCustomerMaster'][0].BuilderEmailAddress1 = this.accountAppModel['BuilderEmailAddress1'];
    }
    if (this.accountAppModel['BuilderMobileNo1']) {
      this.accountModel['TmxCustomerMaster'][0].BuilderMobileNo1 = this.accountAppModel['BuilderMobileNo1'];
    }
    if (this.accountAppModel['ExistingOwnerName1']) {
      this.accountModel['TmxCustomerMaster'][0].ExistingOwnerName1 = this.accountAppModel['ExistingOwnerName1'];
    }
    if (this.accountAppModel['ExistingOwnerCnic1']) {
      this.accountModel['TmxCustomerMaster'][0].ExistingOwnerCnic1 = this.accountAppModel['ExistingOwnerCnic1'];
    }
    if (this.accountAppModel['ExistingEmailAddress1']) {
      this.accountModel['TmxCustomerMaster'][0].ExistingEmailAddress1 = this.accountAppModel['ExistingEmailAddress1'];
    }
    if (this.accountAppModel['ExistingOwnerMobile1']) {
      this.accountModel['TmxCustomerMaster'][0].ExistingOwnerMobile1 = this.accountAppModel['ExistingOwnerMobile1'];
    }
    if (this.accountAppModel['PaymentAmountInDigits']) {
      this.accountModel['TmxCustomerMaster'][0].PaymentAmountInDigits = this.accountAppModel['PaymentAmountInDigits'];
    }if (this.accountAppModel['PaymentAmountInWords']) {
      this.accountModel['TmxCustomerMaster'][0].PaymentAmountInWords = this.accountAppModel['PaymentAmountInWords'];
    }if (this.accountAppModel['TypeOfPayment']) {
      this.accountModel['TmxCustomerMaster'][0].TypeOfPayment = this.accountAppModel['TypeOfPayment'];
    }if (this.accountAppModel['PaymentHandedOverToName']) {
      this.accountModel['TmxCustomerMaster'][0].PaymentHandedOverToName = this.accountAppModel['PaymentHandedOverToName'];
    }if (this.accountAppModel['PaymentHandedOverToCnic']) {
      this.accountModel['TmxCustomerMaster'][0].PaymentHandedOverToCnic = this.accountAppModel['PaymentHandedOverToCnic'];
    }if (this.accountAppModel['BeneficiaryAccountNumber']) {
      this.accountModel['TmxCustomerMaster'][0].BeneficiaryAccountNumber = this.accountAppModel['BeneficiaryAccountNumber'];
    }if (this.accountAppModel['BeneficiaryAccountTitle']) {
      this.accountModel['TmxCustomerMaster'][0].BeneficiaryAccountTitle = this.accountAppModel['BeneficiaryAccountTitle'];
    }


    if (this.accountAppModel['FatherSpouseName']) {
      this.accountModel['TmxCustomerMaster'][0].FatherSpouseName = this.accountAppModel['FatherSpouseName'];
    }
    if (this.accountAppModel['CoApplicantName']) {
      this.accountModel['TmxCustomerMaster'][0].CoApplicantName = this.accountAppModel['CoApplicantName'];
    }if (this.accountAppModel['RelationWithApplicant']) {
      this.accountModel['TmxCustomerMaster'][0].RelationWithApplicant = this.accountAppModel['RelationWithApplicant'];
    }
    if (this.accountAppModel['MotherMaidenName']) {
      this.accountModel['TmxCustomerMaster'][0].MotherMaidenName = this.accountAppModel['MotherMaidenName'];
    }
    if (this.accountAppModel['DOB']) {
      this.accountModel['TmxCustomerMaster'][0].DOB = this.accountAppModel['DOB'];
    }
    if (this.accountAppModel['EmploymentStatus']) {
      this.accountModel['TmxCustomerMaster'][0].EmploymentStatus = this.accountAppModel['EmploymentStatus'];
    }
    if (this.accountAppModel['OtherEmploymentStatus']) {
      this.accountModel['TmxCustomerMaster'][0].OtherEmploymentStatus = this.accountAppModel['OtherEmploymentStatus'];
    }
    if (this.accountAppModel['EmployerName']) {
      this.accountModel['TmxCustomerMaster'][0].EmployerName = this.accountAppModel['EmployerName'];
    }
    if (this.accountAppModel['EmailAddress']) {
      this.accountModel['TmxCustomerMaster'][0].EmailAddress = this.accountAppModel['EmailAddress'];
    }
    if (this.accountAppModel['ResidenceAddress']) {
      this.accountModel['TmxCustomerMaster'][0].ResidenceAddress = this.accountAppModel['ResidenceAddress'];
    }
    if (this.accountAppModel['PermanentAddress']) {
      this.accountModel['TmxCustomerMaster'][0].PermanentAddress = this.accountAppModel['PermanentAddress'];
    }
    if (this.accountAppModel['OfficeAddress']) {
      this.accountModel['TmxCustomerMaster'][0].OfficeAddress = this.accountAppModel['OfficeAddress'];
    }
   if (this.accountAppModel['Branch']) {
      this.accountModel['TmxCustomerMaster'][0].Branch = this.accountAppModel['Branch'];
    }if (this.accountAppModel['IBAN']) {
      this.accountModel['TmxCustomerMaster'][0].AccountNumber = this.accountAppModel['IBAN'];
    }

    if (this.accountAppModel['OPProjectName']) {
      this.accountModel['TmxCustomerMaster'][0].OPProjectName = this.accountAppModel['OPProjectName'];
    }
    if (this.accountAppModel['OPPropertyType']) {
      this.accountModel['TmxCustomerMaster'][0].OPPropertyType = this.accountAppModel['OPPropertyType'];
    }
    if (this.accountAppModel['OPCity']) {
      this.accountModel['TmxCustomerMaster'][0].OPCity = this.accountAppModel['OPCity'];
    }
    if (this.accountAppModel['OPUnitCategories']) {
      this.accountModel['TmxCustomerMaster'][0].OPUnitCategories = this.accountAppModel['OPUnitCategories'];
    }
    if (this.accountAppModel['OPOverallArea']) {
      this.accountModel['TmxCustomerMaster'][0].OPOverallArea = this.accountAppModel['OPOverallArea'];
    }
    if (this.accountAppModel['OPNoOfBedroom']) {
      this.accountModel['TmxCustomerMaster'][0].OPNoOfBedroom = this.accountAppModel['OPNoOfBedroom'];
    }
    if (this.accountAppModel['OPInstallmentPlan']) {
      this.accountModel['TmxCustomerMaster'][0].OPInstallmentPlan = this.accountAppModel['OPInstallmentPlan'];
    }
    if (this.accountAppModel['OPCompletionDate']) {
      this.accountModel['TmxCustomerMaster'][0].OPCompletionDate = this.accountAppModel['OPCompletionDate'];
    }
    if (this.accountAppModel['OPEquityContribution']) {
      this.accountModel['TmxCustomerMaster'][0].OPEquityContribution = this.accountAppModel['OPEquityContribution'];
    }
    if (this.accountAppModel['OPApplicantContribution']) {
      this.accountModel['TmxCustomerMaster'][0].OPApplicantContribution = this.accountAppModel['OPApplicantContribution'];
    }
    if (this.accountAppModel['OPBankContribution']) {
      this.accountModel['TmxCustomerMaster'][0].OPBankContribution = this.accountAppModel['OPBankContribution'];
    }
    if (this.accountAppModel['OPPropertyValue']) {
      this.accountModel['TmxCustomerMaster'][0].OPPropertyValue = this.accountAppModel['OPPropertyValue'];
    }
    if (this.accountAppModel['OPPropertySize']) {
      this.accountModel['TmxCustomerMaster'][0].OPPropertySize = this.accountAppModel['OPPropertySize'];
    }
    if (this.accountAppModel['OPMeasurementUnit']) {
      this.accountModel['TmxCustomerMaster'][0].OPMeasurementUnit = this.accountAppModel['OPMeasurementUnit'];
    }
    if (this.accountAppModel['OPLandArea']) {
      this.accountModel['TmxCustomerMaster'][0].OPLandArea = this.accountAppModel['OPLandArea'];
    }
    if (this.accountAppModel['OPCoveredArea']) {
      this.accountModel['TmxCustomerMaster'][0].OPCoveredArea = this.accountAppModel['OPCoveredArea'];
    }
    if (this.accountAppModel['OPPropertyAddress']) {
      this.accountModel['TmxCustomerMaster'][0].OPPropertyAddress = this.accountAppModel['OPPropertyAddress'];
    }
    if (this.accountAppModel['OPBuilderLink']) {
      this.accountModel['TmxCustomerMaster'][0].OPBuilderLink = this.accountAppModel['OPBuilderLink'];
    }
    if (this.accountAppModel['OPMonthlyInstallment']) {
      this.accountModel['TmxCustomerMaster'][0].OPMonthlyInstallment = this.accountAppModel['OPMonthlyInstallment'];
    }
    if(this.accountAppModel['PSPropertyType']) {
      this.accountModel['TmxCustomerMaster'][0].PSPropertyType = this.accountAppModel['PSPropertyType'];
    }
    if(this.accountAppModel['PSAddressLocationOfProperty']) {
      this.accountModel['TmxCustomerMaster'][0].PSAddressLocationOfProperty = this.accountAppModel['PSAddressLocationOfProperty'];
    }
    if(this.accountAppModel['PSAddressCity']) {
      this.accountModel['TmxCustomerMaster'][0].PSAddressCity = this.accountAppModel['PSAddressCity'];
    }
    if(this.accountAppModel['PSMeasurementUnit']) {
      this.accountModel['TmxCustomerMaster'][0].PSMeasurementUnit = this.accountAppModel['PSMeasurementUnit'];
    }
    if(this.accountAppModel['PSLandArea']) {
      this.accountModel['TmxCustomerMaster'][0].PSLandArea = this.accountAppModel['PSLandArea'];
    }
    if(this.accountAppModel['PSCoveredArea']) {
      this.accountModel['TmxCustomerMaster'][0].PSCoveredArea = this.accountAppModel['PSCoveredArea'];
    }
    if(this.accountAppModel['PSNomineeCompanyName']) {
      this.accountModel['TmxCustomerMaster'][0].PSNomineeCompanyName = this.accountAppModel['PSNomineeCompanyName'];
    }
    if(this.accountAppModel['PSNomineeName']) {
      this.accountModel['TmxCustomerMaster'][0].PSNomineeName = this.accountAppModel['PSNomineeName'];
    }
    if(this.accountAppModel['PSNomineeCNIC']) {
      this.accountModel['TmxCustomerMaster'][0].PSNomineeCNIC = this.accountAppModel['PSNomineeCNIC'];
    }
    if(this.accountAppModel['PSNomineeContactNumberPak']) {
      this.accountModel['TmxCustomerMaster'][0].PSNomineeContactNumberPak = this.accountAppModel['PSNomineeContactNumberPak'];
    }
    if(this.accountAppModel['PSNomineeEmailAddress']) {
      this.accountModel['TmxCustomerMaster'][0].PSNomineeEmailAddress = this.accountAppModel['PSNomineeEmailAddress'];
    }
    if(this.accountAppModel['PSNomineeRelationWithApplicant']) {
      this.accountModel['TmxCustomerMaster'][0].PSNomineeRelationWithApplicant = this.accountAppModel['PSNomineeRelationWithApplicant'];
    }
    if(this.accountAppModel['PSNomineeCompleteAddress']) {
      this.accountModel['TmxCustomerMaster'][0].PSNomineeCompleteAddress = this.accountAppModel['PSNomineeCompleteAddress'];
    }
    if(this.accountAppModel['PSNomineeOtherRelation']) {
      this.accountModel['TmxCustomerMaster'][0].PSNomineeOtherRelation = this.accountAppModel['PSNomineeOtherRelation'];
    }
    if(this.accountAppModel['PSNomineeCity']) {
      this.accountModel['TmxCustomerMaster'][0].PSNomineeCity = this.accountAppModel['PSNomineeCity'];
    }
    if(this.accountAppModel['PSValuationCompany']) {
      this.accountModel['TmxCustomerMaster'][0].PSValuationCompany = this.accountAppModel['PSValuationCompany'];
    }
    if(this.accountAppModel['PSValuationDate']) {
      this.accountModel['TmxCustomerMaster'][0].PSValuationDate = this.accountAppModel['PSValuationDate'];
    }
    if(this.accountAppModel['PSValuationAmount']) {
      this.accountModel['TmxCustomerMaster'][0].PSValuationAmount = this.accountAppModel['PSValuationAmount'];
    }
    if(this.accountAppModel['PSAuthorizedAmount']) {
      this.accountModel['TmxCustomerMaster'][0].PSAuthorizedAmount = this.accountAppModel['PSAuthorizedAmount'];
    }
    if(this.accountAppModel['BeneBankName']) {
      this.accountModel['TmxCustomerMaster'][0].BeneBankName = this.accountAppModel['BeneBankName'];
    }
    if(this.accountAppModel['PSOption']) {
      this.accountModel['TmxCustomerMaster'][0].PSOption = this.accountAppModel['PSOption'];
    }
    if(this.accountAppModel['PSOptionLien']) {
      this.accountModel['TmxCustomerMaster'][0].PSOptionLien = this.accountAppModel['PSOptionLien'];
    }
    if(this.accountAppModel['CoCnic']) {
      this.accountModel['TmxCustomerMaster'][0].CoCnic = this.accountAppModel['CoCnic'];
    }
    if(this.accountAppModel['ContactNumberPak']) {
      this.accountModel['TmxCustomerMaster'][0].ContactNumberPak = this.accountAppModel['ContactNumberPak'];
    }
    if(this.accountAppModel['CoEmailAddress']) {
      this.accountModel['TmxCustomerMaster'][0].CoEmailAddress = this.accountAppModel['CoEmailAddress'];
    }
    if(DataService.get('Checklist')) {
      this.accountModel['TmxLoanApplicationChecklist'] = DataService.get('Checklist');
    }

  }






  setIds(data) {
    var coreFields = ['AccountApplicationId', 'CreatedBy', 'AccountApplicationNumber', 'AccountOpeningRequestDate', 'AccountName'
      , 'ProcessInstanceId', 'ApplicationStatusLkp', 'ProductId', 'UserId'];

    coreFields.forEach(function (field) {
      this.accountAppModel[field] = data[field];
    }.bind(this));

    if (data['TmxCustomerMaster'] && data['TmxCustomerMaster'][0]) {
      if (!this.accountAppModel['TmxCustomerMaster']) {
        this.accountAppModel['TmxCustomerMaster'] = [];
        this.accountAppModel['TmxCustomerMaster'][0] = {};
      }
      this.accountAppModel['TmxCustomerMaster'][0]['CustomerMasterId'] = data['TmxCustomerMaster'][0]['CustomerMasterId'];
      this.accountAppModel['TmxCustomerMaster'][0]['CreatedBy'] = data['TmxCustomerMaster'][0]['CreatedBy'];


      if (data['TmxLoanApplicationChecklist'] && this.accountAppModel['TmxLoanApplicationChecklist']) {
        data['TmxLoanApplicationChecklist'].forEach(function (checklist) {
          var matchingChecklistItem = this.accountAppModel['TmxLoanApplicationChecklist'].find(x => x.LoanProductChecklistId == checklist.LoanProductChecklistId);
          if (matchingChecklistItem) {
            matchingChecklistItem.LoanApplicationChecklistId = checklist.LoanApplicationChecklistId;
            matchingChecklistItem.CreatedBy = checklist.CreatedBy;
          }
        }.bind(this));
      }


    }
  }

  setModelFromData(data) {
    console.log('in setModelFromData');
    console.log(data.LoanType);
    //existing draft application fields
    if(DataService.get('IsOld') == '1'){
      this.oldApp = true;
    }else{
      this.oldApp = false;
    }

    if(this.oldApp){

      if (DataService.get('Checklist')) {
        this.accountAppModel['TmxLoanApplicationChecklist'] = DataService.get('Checklist');

      }
      if (data['TmxApplicantDetail']) {

        this.applicantDetails = data['TmxApplicantDetail'];
      }
      if (data['TmxCoApplicantNomineeDetail']) {

        this.coApplicantNomineeDetails = data['TmxCoApplicantNomineeDetail'];
      }
      if (data['RefNo']) {

        this.accountAppModel.AccountApplicationNumber = data['RefNo'];
      }
      if (data['EmailUDF']) {

        this.accountAppModel.EmailAddress = data['EmailUDF'];
      }

      if (data['PrimaryApplicantName']) {

        this.accountAppModel.PrimaryApplicantName = data['PrimaryApplicantName'];
        this.accountAppModel.AccountName = data['PrimaryApplicantName'];
      }
      if (data['LoanType']) {

        this.accountAppModel.LoanType = data['LoanType'];
        this.onLoanTypeSelected(this.accountAppModel.LoanType);
        // if(this.Lookups.LoanType.filter(x => x.LookupId == this.accountAppModel.LoanType).map(y=>y.HiddenValue) == 'Payment by Self (Cash)'){
        //   this.PaymentBySelf = true;

        // }else{
        //   this.PaymentBySelf = false;

        // }
      }
      if (data['RAGProductType']) {
        this.accountAppModel.RAGProductType = data['RAGProductType'];
        this.onProductTypeSelected(this.accountAppModel.RAGProductType);
      }
      if (data['ApplicationType']) {

        this.accountAppModel.ApplicationType = data['ApplicationType'];
        this.onApplicationTypeSelected(this.accountAppModel.ApplicationType);
      } if (data['PricingMarkupType']) {

        this.accountAppModel.PricingMarkupType = data['PricingMarkupType'];
      }
      if (data['PropertyType']) {

        this.accountAppModel.PropertyType = data['PropertyType'];
      }
      if (data['ApproxPropertyType']) {

        this.accountAppModel.ApproxPropertyType = data['ApproxPropertyType'];
      }
      if (data['PropertyToBuy']) {

        this.accountAppModel.PropertyToBuy = data['PropertyToBuy'];
        this.onPropertyToBuySelected(this.accountAppModel.PropertyToBuy);
      }
      if (data['ApproxPropertyValue']) {

        this.accountAppModel.ApproxPropertyValue = data['ApproxPropertyValue'];
        this.onFinValueChange();
      }
      if (data['PropertyValue']) {

        this.accountAppModel.PropertyValue = data['PropertyValue'];
      }
      if (data['FinancingAmount']) {

        this.accountAppModel.FinancingAmount = data['FinancingAmount'];
        this.onFinValueChange();
      } if (data['LoanTenure']) {

        this.accountAppModel.LoanTenure = data['LoanTenure'];
      }
      if (data['GMSSTier']) {

        this.accountAppModel.GMSSTier = data['GMSSTier'];
      }
      if (data['InstallmentAmount']) {

        this.accountAppModel.InstallmentAmount = data['InstallmentAmount'];
      }
      if (data['PropertyDeveloperName']) {

        this.accountAppModel.PropertyDeveloperName = data['PropertyDeveloperName'];
      }
      if (data['City']) {

        this.accountAppModel.City = data['City'];
      }
      if (data['PropertyValue']) {

        this.accountAppModel.PropertyValue = data['PropertyValue'];
      }
      if (data['PropertySize']) {

        this.accountAppModel.PropertySize = data['PropertySize'];
      }
      if (data['MeasurementUnit']) {

        this.accountAppModel.MeasurementUnit = data['MeasurementUnit'];
      }if (data['LandArea']) {

        this.accountAppModel.LandArea = data['LandArea'];
      }
      if (data['CoveredArea']) {

        this.accountAppModel.CoveredArea = data['CoveredArea'];
      }
      if (data['AddressLocationOfProperty']) {

        this.accountAppModel.AddressLocationOfProperty = data['AddressLocationOfProperty'];
      }
      if (data['AddressCity']) {

        this.accountAppModel.AddressCity = data['AddressCity'];
      }
      if (data['ExistingOwnerName']) {

        this.accountAppModel.ExistingOwnerName = data['ExistingOwnerName'];
      }

      if (data['Cnic']) {

        this.accountAppModel.Cnic = data['Cnic'];
      }
      if (data['PropertyOwnerShip']) {

        this.accountAppModel.PropertyOwnerShip = data['PropertyOwnerShip'];
      }
      if (data['CounteryName']) {

        this.accountAppModel.CounteryName = data['CounteryName'];
      }
      if (data['Address']) {

        this.accountAppModel.Address = data['Address'];
        //this.accountAppModel.BusinessAddress = data['Address'];
      }
      if (data['BusinessAddress']) {


        this.accountAppModel.BusinessAddress = data['BusinessAddress'];
      }
      if (data['ContactNumberOutsidePak']) {

        this.accountAppModel.ContactNumberOutsidePak = data['ContactNumberOutsidePak'];
      }
      if (data['IsSalaried']) {

        this.accountAppModel.IsSalaried = data['IsSalaried'];
      }  if (data['EmployeeName']) {

        this.accountAppModel.EmployeeName = data['EmployeeName'];
      }if (data['EmployeeSince']) {

        this.accountAppModel.EmployeeSince = data['EmployeeSince'];
      }if (data['Salary']) {

        this.accountAppModel.Salary = data['Salary'];
      }if (data['NameOfBusiness']) {

        this.accountAppModel.NameOfBusiness = data['NameOfBusiness'];
      }
      if (data['StatusOfBusiness']) {

        this.accountAppModel.StatusOfBusiness = data['StatusOfBusiness'];
      }if (data['YearsInBusiness']) {

        this.accountAppModel.YearsInBusiness = data['YearsInBusiness'];
      }if (data['MonthlyIncome']) {

        this.accountAppModel.MonthlyIncome = data['MonthlyIncome'];
      }if (data['BeneficiaryName']) {

        this.accountAppModel.BeneficiaryName = data['BeneficiaryName'];
      }
      if (data['ExistingOwnerName1']) {

        this.accountAppModel.ExistingOwnerName1 = data['ExistingOwnerName1'];
      }
      if (data['ExistingOwnerCnic1']) {

        this.accountAppModel.ExistingOwnerCnic1 = data['ExistingOwnerCnic1'];
      }
      if (data['BuilderName1']) {

        this.accountAppModel.BuilderName1 = data['BuilderName1'];
      }
      if (data['BuilderNTNNo1']) {

        this.accountAppModel.BuilderNTNNo1 = data['BuilderNTNNo1'];
      }
      if (data['BuilderEmailAddress1']) {

        this.accountAppModel.BuilderEmailAddress1 = data['BuilderEmailAddress1'];
      }
      if (data['BuilderMobileNo1']) {

        this.accountAppModel.BuilderMobileNo1 = data['BuilderMobileNo1'];
      }
      if (data['ExistingEmailAddress1']) {

        this.accountAppModel.ExistingEmailAddress1 = data['ExistingEmailAddress1'];
      }
      if (data['ExistingOwnerMobile1']) {

        this.accountAppModel.ExistingOwnerMobile1 = data['ExistingOwnerMobile1'];
      }
      if (data['PSPropertyType']) {

        this.accountAppModel.PSPropertyType = data['PSPropertyType'];
      }
      if (data['PSAddressLocationOfProperty']) {

        this.accountAppModel.PSAddressLocationOfProperty = data['PSAddressLocationOfProperty'];
      }
      if (data['PSAddressCity']) {

        this.accountAppModel.PSAddressCity = data['PSAddressCity'];
      }
      if (data['PSMeasurementUnit']) {

        this.accountAppModel.PSMeasurementUnit = data['PSMeasurementUnit'];
      }
      if (data['PSLandArea']) {

        this.accountAppModel.PSLandArea = data['PSLandArea'];
      }
      if (data['PSOption']) {

        this.accountAppModel.PSOption = data['PSOption'];
        this.onPSOptionSelected(this.accountAppModel.PSOption);
      }
      if (data['PSValuationCompany']) {

        this.accountAppModel.PSValuationCompany = data['PSValuationCompany'];
      }
      if (data['PSValuationDate']) {

        this.accountAppModel.PSValuationDate = data['PSValuationDate'];
      }
      if (data['PSValuationAmount']) {

        this.accountAppModel.PSValuationAmount = data['PSValuationAmount'];
      }
      if (data['PSAuthorizedAmount']) {

        this.accountAppModel.PSAuthorizedAmount = data['PSAuthorizedAmount'];
      }
      if (data['BeneBankName']) {

        this.accountAppModel.BeneBankName = data['BeneBankName'];
      }
      if (data['PSCoveredArea']) {

        this.accountAppModel.PSCoveredArea = data['PSCoveredArea'];
      }
      if (data['CoCnic']) {

        this.accountAppModel.CoCnic = data['CoCnic'];
      }
      if (data['ContactNumberPak']) {

        this.accountAppModel.ContactNumberPak = data['ContactNumberPak'];
      }
      if (data['RelationWithApplicant']) {

        this.accountAppModel.RelationWithApplicant = data['RelationWithApplicant'];
      }
      if (data['MotherMaidenName']) {

        this.accountAppModel.MotherMaidenName = data['MotherMaidenName'];
      }
      if (data['DOB']) {

        this.accountAppModel.DOB = data['DOB'];
      }
      if (data['EmploymentStatus']) {

        this.accountAppModel.EmploymentStatus = data['EmploymentStatus'];
      }
      if (data['EmployerName']) {

        this.accountAppModel.EmployerName = data['EmployerName'];
      }
      if (data['CoEmailAddress']) {

        this.accountAppModel.CoEmailAddress = data['CoEmailAddress'];
      }
      if (data['ResidenceAddress']) {

        this.accountAppModel.ResidenceAddress = data['ResidenceAddress'];
      }
      if (data['PermanentAddress']) {

        this.accountAppModel.PermanentAddress = data['PermanentAddress'];
      }
      if (data['OfficeAddress']) {

        this.accountAppModel.OfficeAddress = data['OfficeAddress'];
      }
      if (data['BuilderName']) {

        this.accountAppModel.BuilderName = data['BuilderName'];
      }
      if (data['PaymentAmountInDigits']) {

        this.accountAppModel.PaymentAmountInDigits = data['PaymentAmountInDigits'];
      }
      if (data['PaymentAmountInWords']) {

        this.accountAppModel.PaymentAmountInWords = data['PaymentAmountInWords'];
      }
      if (data['TypeOfPayment']) {

        this.accountAppModel.TypeOfPayment = data['TypeOfPayment'];
        this.onPaymentTypeSelected(this.accountAppModel.TypeOfPayment);
      }
      if (data['PaymentHandedOverToName']) {

        this.accountAppModel.PaymentHandedOverToName = data['PaymentHandedOverToName'];
      }
      if (data['PaymentHandedOverToCnic']) {

        this.accountAppModel.PaymentHandedOverToCnic = data['PaymentHandedOverToCnic'];
      }
      if (data['BeneficiaryAccountNumber']) {

        this.accountAppModel.BeneficiaryAccountNumber = data['BeneficiaryAccountNumber'];
      }
      if (data['BeneficiaryAccountTitle']) {

        this.accountAppModel.BeneficiaryAccountTitle = data['BeneficiaryAccountTitle'];
      }

      if (data['FatherSpouseName']) {

        this.accountAppModel.FatherSpouseName = data['FatherSpouseName'];
      }
      if (data['CoApplicantName']) {

        this.accountAppModel.CoApplicantName = data['CoApplicantName'];
      }
      if (data['RelationWithApplicant']) {

        this.accountAppModel.RelationWithApplicant = data['RelationWithApplicant'];
      }



      if (data['AccountApplicationId']) {

        this.accountAppModel.AccountApplicationId = data['AccountApplicationId'];
      }

      if (data['AccountTitle']) {

        this.accountAppModel.PrimaryApplicantName = data['AccountTitle'];
        this.accountAppModel.AccountTitle = data['AccountTitle'];
        this.accountAppModel.AccountName = data['AccountTitle'];

      }
      if (data['AccountNumber']) {

        this.accountAppModel.IBAN = data['AccountNumber'];
        this.accountAppModel.AccountNumber = data['AccountNumber'];
      }

      if (data['Branch']) {

        this.accountAppModel.Branch = data['Branch'];
      }

      if (data['OPProjectName']) {

        this.accountAppModel.OPProjectName = data['OPProjectName'];
        this.onPropertyPropertyDeveloperNameSelected(this.accountAppModel.OPProjectName);
      }
      if (data['OPPropertyType']) {

        this.accountAppModel.OPPropertyType = data['OPPropertyType'];
      }
      if (data['OPCity']) {

        this.accountAppModel.OPCity = data['OPCity'];
      }
      if (data['OPUnitCategories']) {

        this.accountAppModel.OPUnitCategories = data['OPUnitCategories'];
      }
      if (data['OPOverallArea']) {

        this.accountAppModel.OPOverallArea = data['OPOverallArea'];
      }
      if (data['OPNoOfBedroom']) {

        this.accountAppModel.OPNoOfBedroom = data['OPNoOfBedroom'];
      }
      if (data['OPInstallmentPlan']) {

        this.accountAppModel.OPInstallmentPlan = data['OPInstallmentPlan'];
      }
      if (data['OPCompletionDate']) {

        this.accountAppModel.OPCompletionDate = data['OPCompletionDate'];
      }
      if (data['OPEquityContribution']) {

        this.accountAppModel.OPEquityContribution = data['OPEquityContribution'];
        this.calculateEquityContribution(this.accountAppModel.OPEquityContribution);
      }
      if (data['OPMonthlyInstallment']) {

        this.accountAppModel.OPMonthlyInstallment = data['OPMonthlyInstallment'];
      }
      if (data['OPPropertyValue']) {

        this.accountAppModel.OPPropertyValue = data['OPPropertyValue'];
      }
      if (data['OPApplicantContribution']) {

        this.accountAppModel.OPApplicantContribution = data['OPApplicantContribution'];
      }
      if (data['OPBankContribution']) {

        this.accountAppModel.OPBankContribution = data['OPBankContribution'];
      }
      if (data['OPPropertySize']) {

        this.accountAppModel.OPPropertySize = data['OPPropertySize'];
      }
      if (data['OPPropertyAddress']) {

        this.accountAppModel.OPPropertyAddress = data['OPPropertyAddress'];
      }
      if (data['OPBuilderLink']) {

        this.accountAppModel.OPBuilderLink = data['OPBuilderLink'];
      }
      if (data['PSNomineeCompanyName']) {

        this.accountAppModel.PSNomineeCompanyName = data['PSNomineeCompanyName'];
      }
      if (data['PSNomineeName']) {

        this.accountAppModel.PSNomineeName = data['PSNomineeName'];
      }
      if (data['PSNomineeCNIC']) {

        this.accountAppModel.PSNomineeCNIC = data['PSNomineeCNIC'];
      }
      if (data['PSNomineeContactNumberPak']) {

        this.accountAppModel.PSNomineeContactNumberPak = data['PSNomineeContactNumberPak'];
      }
      if (data['PSNomineeEmailAddress']) {

        this.accountAppModel.PSNomineeEmailAddress = data['PSNomineeEmailAddress'];
      }
      if (data['PSNomineeRelationWithApplicant']) {

        this.accountAppModel.PSNomineeRelationWithApplicant = data['PSNomineeRelationWithApplicant'];
      }
      if (data['PSNomineeOtherRelation']) {

        this.accountAppModel.PSNomineeOtherRelation = data['PSNomineeOtherRelation'];
      }
      if (data['PSNomineeCompleteAddress']) {

        this.accountAppModel.PSNomineeCompleteAddress = data['PSNomineeCompleteAddress'];
      }
      if (data['PSNomineeCity']) {

        this.accountAppModel.PSNomineeCity = data['PSNomineeCity'];
      }


    }
    else{
//RDA auto populate fields
if (data['AccountTitle']) {

  this.accountAppModel.PrimaryApplicantName = data['AccountTitle'];
  this.accountAppModel.AccountTitle = data['AccountTitle'];

}

if (data['CounteryName']) {

  this.accountAppModel.CounteryName = data['CounteryName'];
}
if (data['Address']) {

  this.accountAppModel.Address = data['Address'];
  //this.accountAppModel.BusinessAddress = data['Address'];
}
if (data['BusinessAddress']) {


  this.accountAppModel.BusinessAddress = data['BusinessAddress'];
}
if (data['Sms2']) {

  this.accountAppModel.ContactNumberOutsidePak = data['Sms2'];
}
if (data['Email1']) {

  this.accountAppModel.EmailAddress = data['Email1'];
}


if(data['OccType'].toLowerCase()=='business' && data['EmpName']){
  this.accountAppModel.NameOfBusiness = data['EmpName'];
  this.accountAppModel.IsSalaried = false;
}
else if (data['OccType'].toLowerCase()=='salaried' && data['EmpName']) {
 this.accountAppModel.IsSalaried = true;
  this.accountAppModel.EmployeeName = data['EmpName'];
}else{
  this.accountAppModel.IsSalaried = false;
}
if (data['Sal']) {

  this.accountAppModel.Salary = data['Sal'];
}
if (data['NetMonIn']) {

  this.accountAppModel.BusinessMonthlyIncome = data['NetMonIn'];
}
if (data['IBAN']) {

  this.accountAppModel.IBAN = data['IBAN'];
  this.accountAppModel.AccountNumber = data['IBAN'];
}

if (data['Sms1']) {

  this.accountAppModel.OffPhone = data['Sms1'];
}


if (data['JobType']) {

  this.accountAppModel.JobType = data['JobType'];
}
if (data['CompanyBook']) {
  this.accountAppModel.Branch = this.lookupService.Brancheslookups.filter(br=>br.BranchCode == data['CompanyBook']).map(br=>br.BranchName)[0];
  //this.accountAppModel.Branch = data['CompanyBook'];
}


    }

    //this.setApplicantModel();
  }




  cancelClick() {

    console.log(this.accountAppModel["TmxApplicationDetail"][0]);
  }
  onTNCchange(data) {
    this.showSubmit = data;
    this.firebase.logEvent('I Agree with TnCs');
  }


  goToNextStep(stepper: MatStepper) {
        if(this.smallScreen)
    { console.log("Inside");
      const stepId = stepper._getStepLabelId(stepper.selectedIndex);
      const stepElement = document.getElementById(stepId);
      if (stepElement) {
        stepElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
      }
    }
    let valid = this.manualChecks(stepper);
    if (!valid) {
      stepper.selected.interacted = true;
      return;
    }
    var switched = stepper.next();
    const app = document.getElementsByClassName("mat-step-label mat-step-label-active mat-step-label-selected");
    console.log(app[0]);

    switch(app[0]['innerText'])
    {
      case 'Basic Account Details':
        this.firebase.logEvent('Navigation | Applicant Details');
        break;

      case 'Applicant Details':
        this.firebase.logEvent('Navigation | Next Of KIN');
        break;

      case 'Next Of Kin':
        this.firebase.logEvent('Navigation | Income and Bank Details');
        break;

      case 'Income and Bank Details':
        this.firebase.logEvent('Navigation | Documents');
        break;

      case 'Documents':
        this.firebase.logEvent('Navigation | Declarations');
        break;

      default :
        this.firebase.logEvent('Navigation | Basic Account Details');
        break;

    }

    this.postDetails('save', true);
  }



  manualChecks(stepper: MatStepper): boolean {
    let valid = true;

    return valid;
  }





  AddDocument(data) {

    // Keep this check in the end because there is a return condition when show multiple accounts is set true.
    if (data) {
      let selectedLkp = this.Lookups.AccountOperationLkp.find(x => x.LookupId == data);
      if (selectedLkp) {

      }
    }

  }




  @HostListener('window:beforeunload', ['$event'])
  onWindowClose(event: any): void {
    // Do something
    if (!this.appConfig.testingMode && !this.allowExit) {
      event.returnValue = false;
      event.preventDefault();
    }
  }
  logApplication() {
    console.log(this.applicantDetails);
  }
}

